import * as React from 'react';

import {
  App,
  AppInstallMeta,
  Beacon,
  Beacons,
  Bubble,
  BucketPriority,
  Carrier,
  City,
  CityGroup,
  DraftState,
  GlanceContextType,
  GlanceDraft,
  GlanceType,
  LanguageLimit,
  OmSdkInfoType,
  PropositionType,
  PublisherData,
  Region,
  Role,
  SessionMode,
  SqlStudioSegment,
  StoryType,
  StudioCategory,
  SubscriptionStatus,
  TargetDevice,
  TargetDeviceProperties,
  UserNetworkType,
  AppOpenNudgeConfig,
  AppOpenNotificationConfig,
  ChannelType,
  Programmatic,
  DspCampaignData,
  EU,
} from 'glance-datatypes';
import {
  BeaconType,
  CategorySource,
  EmojiMapping,
  PublishButtonAtributes,
  SegmentSource,
} from '../types';
import {
  Chip,
  DropDownMenu,
  FlatButton,
  FontIcon,
  GridList,
  GridTile,
  IconButton,
  MenuItem,
  RaisedButton,
  SelectField,
  TextField,
  Divider,
  Toggle,
} from 'material-ui';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {
  blue300,
  cyan500,
  green500,
  grey500,
  indigo500,
  red500,
  yellowA700,
} from 'material-ui/styles/colors';
import { getPublishButtonAtributes, isArticle } from '../draftsHelper';
import {
  highPriorityBackgroundColor,
  highPriorityLabelColor,
  skipSummaryBackgroundColor,
  skipSummaryLabelColor,
  styles,
} from '../styles/draftDetailsStyle';

import Constants from '../../../Constants';
import BeaconTableRow from './BeaconTableRow';
import ChipInput from 'material-ui-chip-input';
import { GlanceDraftDetailsProps } from '../types';
import JerseyRestApiService from '../../../JerseyRestApiService';
import MultiSelectDropdown from '../../../components/common/MultiSelectDropdown/MultiSelectDropdown';
import { Tooltip } from 'react-lightweight-tooltip';
import Utils, { MONTHS, regionFilters, regionNames, stateFilters } from '../../../Utils';
import { connect } from 'react-redux';
import { get } from 'lodash';
import RestService from '../../../RestService';
import Popover from 'material-ui/Popover';
import { LottieAnimation } from './LottieWrapper';
import { EmojiUploadError } from '../types';
import { Selected } from '../../../components/svg/Selected';
import { FileUpload } from '../../../components/svg/FileUpload';
import { Ban } from '../../../components/svg/Ban';
import { Pencil } from '../../../components/svg/Pencil';

const TAG_SOURCE = [
  'Politics',
  'National',
  'International',
  'Entertainment',
  'Business/Markets',
  'Automotive',
  'Fashion',
  'Health and Fitness',
  'Nature',
  'Space',
  'Travel',
  'Sci/Tech',
  'Sports',
  'Culture/Lifestyle',
  'DIY/Life Hacks',
  'Photo Stories',
  'Interesting',
  'Sports',
  'Animals',
  'Humour',
  'Social Media',
  'Facts',
  'Motivation',
  'Puzzles',
  "What's today",
  'Food',
  'Consumer Product',
].sort();
const SPONSORED_SESSION_MODE_LIST = [
  { name: 'LOCKSCREEN', value: SessionMode.DEFAULT },
  { name: 'BINGE', value: SessionMode.BINGE },
  { name: 'IN-GAME REWARDED VIDEOS', value: SessionMode.GAME_REWARDED },
  { name: 'GAME SPLASH', value: SessionMode.GAME_SPLASH },
];

const SESSION_MODE_LIST_OPTIONS = [
  { value: 'LOCKSCREEN' },
  { value: 'BINGE' },
  { value: 'IN-GAME REWARDED VIDEOS' },
  { value: 'GAME SPLASH' },
];

const GLANCE_TV_LIST_OPTIONS = [
  { value: SessionMode.SCREENSAVER, name: 'SCREENSAVER' },
  { value: SessionMode.PATCHWALL_STORIES, name: 'PATCHWALL_STORIES' },
];

const sessionModeMappingSelected = {
  ANY: 0,
  LOCKSCREEN: 1,
  BINGE: 2,
  HIGHLIGHTS: 3,
  'IN-GAME REWARDED VIDEOS': 4,
  'GAME SPLASH': 5,
  SCREENSAVER: 6,
  PATCHWALL_STORIES: 7,
};

export const sessionModeMapping = {
  0: 'ANY',
  1: 'LOCKSCREEN',
  2: 'BINGE',
  3: 'HIGHLIGHTS',
  4: 'IN-GAME REWARDED VIDEOS',
  5: 'GAME SPLASH',
  6: 'SCREENSAVER',
  7: 'PATCHWALL_STORIES',
};

const MAX_CATEGORY = {
  DEFAULT: 2,
  SPONSORED: 6,
};

const networkTargetingOptions = [
  { value: 'OFFLINE' },
  { value: 'WIFI' },
  { value: 'MOBILE_DATA' },
];

const USER_NETWORK_TYPE = {
  OFFLINE: 0,
  WIFI: 1,
  MOBILE_DATA: 2,
};

const USER_NETWORK_TYPE_SELECTED = {
  0: 'OFFLINE',
  1: 'WIFI',
  2: 'MOBILE_DATA',
};

const glanceTypes = {
  1: 'WALLPAPER',
  2: 'STORY',
  3: 'RESERVED_STORY',
  4: 'SPONSORED',
};

const TITLE_LENGTH_LIMIT_NON_SPONSORED = 50;
const TITLE_LENGTH_LIMIT_SPONSORED = 40;
const SHORT_TITLE_LENGTH_LIMIT = 25;
const DEFAULT_SUMMARY_LENGTH_LIMIT = 150;
const LS_SUBTEXT_LIMIT = 10;
const CTA_TEXT_LENGTH_LIMIT = 11;
const NEGATIVE_TARGET_TYPE = ['absent', 'anyAbsent'];
const POSITIVE_TARGET_TYPE = ['present', 'anyPresent'];

const CATEGORY_SOURCE_CONFIG = { text: 'displayName', value: 'category' };
const CITY_SOURCE_CONFIG = { text: 'groupName', value: 'groupName' };
const CARRIER_SOURCE_CONFIG = { text: 'carrierName', value: 'carrierId' };
const SEGMENT_SOURCE_CONFIG = { text: 'text', value: 'id' };
const TARGET_SOURCE_CONFIG = { text: 'name', value: 'packageId' };
const BUBBLE_SOURCE_CONFIG = { text: 'qualifier', value: 'bubbleId' };

const EMOJI_FORMAT = {
  LOTTIE: 'LOTTIE',
  GIF: 'GIF',
  SVG: 'SVG',
  PNG: 'PNG',
  UNKNOWN: 'UNKNOWN',
};

interface Emoji {
  id: number;
  cdnUrl: string;
  mediaType: string;
}

interface SelectedEmoji {
  emoji: Emoji;
  target: any;
  idx: number;
}

interface ValueProp {
  id: string;
  name: string;
}

interface Eu {
  id: string;
  name: string;
  country: Region;
  valueProps: ValueProp[];
}

interface State {
  programmaticDetail: Programmatic;
  appOpenNudgeConfig: AppOpenNudgeConfig;
  appOpenNotificationConfig: AppOpenNotificationConfig;
  titleExceededSize?: number;
  shortTitleExceededSize?: number;
  summaryExceededSize?: number;
  cheesySummaryExceededSize?: number;
  summaryLimit?: number;
  publisherDatas?: Map<string, PublisherData>;
  categorySource: CategorySource[];
  categoryMap: Map<string, StudioCategory>;
  linkType: string;
  dailyWeeklyCapError: boolean;
  beaconType: BeaconType;
  beaconPartner?: string;
  beaconUrl: string;
  beaconError: string;
  minDurationInSecs: number;
  delayDurationInMillis: number;
  beacons: Beacons;
  publisherData: PublisherData;
  cities: City[];
  cityGroups: CityGroup[];
  citySource: CityGroup[];
  carrierMetas: Carrier[];
  carrierSource: Carrier[];
  negativeTargets: any[];
  positiveTargets: any;
  negativeTargetingType: string;
  positiveTargetingType: string;
  negativeTargetSource: any[];
  positiveTargetSource: any;
  segments: SqlStudioSegment[];
  antiSegments: SqlStudioSegment[];
  segmentSource: SegmentSource[];
  ctaType: PropositionType;
  publishValue: number;
  publishButtonDisability: boolean;
  publishButtonTooltipText: string;
  bubbles: Bubble[];
  filteredBubbles: Bubble[];
  sortedBubbles: any;
  userNetworkTypes: UserNetworkType[];
  renderSessionProperties: any;
  lsSubTextExceededSize: boolean;
  lockscreenCtaTextExceededSize?: boolean;
  ctaTextExceededSize?: boolean;
  campaignObjectiveList: any[];
  showTriggerPercentage: boolean;
  selectedOciAppId?: string;
  selectedWebPeekNotiAppId?: string;
  CtaViewExceededHeight: boolean;
  rankInBubble: number;
  storyCount: number;
  publishedBubbleId: string;
  publishedRank: number;
  currEmojis?: Emoji[]; // this is not optional state, keeping it optional due to studio limitation (reset state on prop recieve)
  selectedEmoji: SelectedEmoji;
  showPopover: boolean;
  allEmojis: Emoji[];
  chosenEmoji: Emoji;
  hoveredEmoji: number;
  fileUploadError: boolean;
  sameEmoji: number;
  emojiUploadError: EmojiUploadError[];
  overrideWallpaperMode: boolean;
  eu?: string;
  valueProp?: string;
  allEus?: Eu[];
  autoOpenCta?: boolean;
  sourceNameList?: string[];
  dspCampaignData: DspCampaignData;
}

interface ImageDimension {
  width: number;
  height: number;
}

interface File {
  lastModified: any;
  lastModifiedDate: any;
  name: any;
  size: any;
  type: any;
  webkitRelativePath: any;
}

const rendersessionPropertiesMapping = (params) => {
  const { tvVideoPeek = null } = params.peek || {};
  let selectedRenderSession = [];
  let sessionList;

  let data = Utils.getRenderSessionData(params);
  if (tvVideoPeek) {
    sessionList = GLANCE_TV_LIST_OPTIONS.filter((item) =>
      data.includes(item.value),
    );
  } else {
    sessionList = SPONSORED_SESSION_MODE_LIST.filter((item) =>
      data.includes(item.value),
    );
  }
  sessionList.forEach((element) => {
    selectedRenderSession.push({
      value: sessionModeMapping[element.value],
    });
  });
  return selectedRenderSession;
};

class GlanceDraftDetails extends React.Component<
  GlanceDraftDetailsProps,
  State
> {
  constructor(props: GlanceDraftDetailsProps) {
    super(props);
    const publisherDatas: Map<string, PublisherData> = new Map<
      string,
      PublisherData
    >();
    const { studioAppConfig, glanceDraftData } = this.props;
    const { beacons } = glanceDraftData;
    const categorySource = [];
    const categoryMap = new Map<string, StudioCategory>();
    this.state = {
      publisherDatas,
      categorySource,
      categoryMap,
      eu: get(glanceDraftData, 'eu'),
      valueProp: get(glanceDraftData, 'valueProp'),
      allEus: [],
      linkType: '',
      dailyWeeklyCapError: false,
      beaconType: BeaconType.RENDER,
      beaconUrl: null,
      beaconError: '',
      minDurationInSecs: 0,
      delayDurationInMillis: null,
      beacons: beacons,
      userNetworkTypes: [],
      publisherData: null,
      cities: [],
      cityGroups: [],
      citySource: [],
      carrierMetas: [],
      carrierSource: [],
      negativeTargets: [],
      positiveTargets: [],
      negativeTargetingType: null,
      positiveTargetingType: null,
      negativeTargetSource: [],
      positiveTargetSource: [],
      segments: [],
      bubbles: [],
      filteredBubbles: [],
      antiSegments: [],
      segmentSource: [],
      publishValue: 0,
      publishButtonDisability: false,
      publishButtonTooltipText: '',
      ctaType: null,
      sortedBubbles: [],
      lsSubTextExceededSize: false,
      renderSessionProperties: rendersessionPropertiesMapping(glanceDraftData),
      campaignObjectiveList: [],
      showTriggerPercentage: false,
      selectedOciAppId: '',
      CtaViewExceededHeight: false,
      rankInBubble: 1,
      storyCount: 0,
      publishedBubbleId: '',
      publishedRank: null,
      overrideWallpaperMode: false,
      currEmojis: [
        {
          id: 1,
          cdnUrl:
            'https://glance.l.inmobicdn.net/public/glancetv/emoji/stage/emoji_heart.png',
          mediaType: 'PNG',
        },
        {
          id: 2,
          cdnUrl:
            'https://glance.l.inmobicdn.net/public/glancetv/emoji/stage/emoji_clap.png',
          mediaType: 'PNG',
        },
        {
          id: 3,
          cdnUrl:
            'https://glance.l.inmobicdn.net/public/glancetv/emoji/stage/emoji_fire.png',
          mediaType: 'PNG',
        },
      ],
      showPopover: false,
      allEmojis: [],
      selectedEmoji: {
        emoji: null,
        target: null,
        idx: null,
      },
      chosenEmoji: null,
      hoveredEmoji: null,
      fileUploadError: false,
      sameEmoji: null,
      emojiUploadError: [],
      appOpenNudgeConfig: get(glanceDraftData, 'ociConfigs.appOpenNudgeConfig'),
      appOpenNotificationConfig: get(
        glanceDraftData,
        'ociConfigs.appOpenNotificationConfig',
      ),
      programmaticDetail: get(
        glanceDraftData,
        'Programmatic.programmaticDetail',
      ),
      autoOpenCta: false,
      dspCampaignData: get(glanceDraftData, 'dspCampaignData'),
    };
  }

  componentDidMount() {
    const initialStateFromProp = this.getInitialStateFromProp(this.props);
    this.setState((state, props) => ({
      ...initialStateFromProp,
    }));
    this.setEuAndValuePropSource();
    this.getEmojiMapping();
  }

  componentWillReceiveProps(nextProps: GlanceDraftDetailsProps) {
    const initialStateFromProp = this.getInitialStateFromProp(nextProps);
    const bubbleId = nextProps.glanceDraftData.bubbleId;
    this.setState((state, props) => ({
      ...initialStateFromProp,
    }));

    if (
      bubbleId &&
      !nextProps.bubbleData &&
      this.props.detailed &&
      !this.state.bubbles.some((item) => item.bubbleId === bubbleId)
    ) {
      JerseyRestApiService.getBubbleById(bubbleId)
        .then((response) => {
          this.setState({
            ...this.state,
            bubbles: [...this.state.bubbles, response[bubbleId]],
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (nextProps.bubbleData) {
      if (
        !this.state.bubbles.some(
          (item) => item.bubbleId === nextProps.bubbleData.bubbleId,
        )
      ) {
        this.setState({
          ...this.state,
          bubbles: [...this.state.bubbles, nextProps.bubbleData],
        });
      }
    }
  }

  setEuAndValuePropSource = () => {
    RestService.getEUs((response) => {
      this.setState({
        ...this.state,
        allEus: response,
      })
    });
  };

  getInitialStateFromProp = (props: GlanceDraftDetailsProps) => {
    const publisherDatas: Map<string, PublisherData> = new Map<
      string,
      PublisherData
    >();
    const {
      studioAppConfig,
      glanceDraftData,
      editable,
      pristine,
      removed,
    } = props;
    studioAppConfig.publishers.forEach((publisher) => {
      publisherDatas.set(
        publisher.id,
        new PublisherData({
          id: publisher.id,
          displayName: publisher.displayName,
          logoUrl: publisher.logoUrl,
          advertiserId: publisher.advertiserId,

        }),
      );
    });
    const {
      peek,
      beacons,
      carriers,
      cityIds,
      segmentIds,
      antiSegmentIds,
      targeting,
      type,
      publisherData,
      editMeta,
      rankInBubble,
      adCoefficient,
      bucketPriority,
      campaignMeta,
      // comment/uncomment for network types
      userNetworkTypes,
    } = glanceDraftData;
    const ecpm = campaignMeta ? campaignMeta.eCpm : null;
    const categorySource = [];
    const categoryMap = new Map<string, StudioCategory>();
    studioAppConfig.categories.forEach((category) => {
      categorySource.push({
        displayName: category.displayName,
        category: category,
      } as CategorySource);
      categoryMap.set(category.id, category);
    });

    let linkType: string;
    if (peek) {
      if (peek.videoUrl) {
        linkType = 'videoUrl';
      } else if (peek.webPeekUrl) {
        linkType = 'webPeekUrl';
      } else if (peek.ctaUrl) {
        linkType = 'ctaUrl';
      } else {
        linkType = 'linkType_unknown';
      }
    }

    let cities = [];
    let cityGroups = [];
    let carrierMetas = [];
    let segments = [];
    let antiSegments = [];
    let positiveTargets = [];
    let negativeTargets = [];
    let negativeTargetingType = 'absent';
    let positiveTargetingType = 'present';
    let selectedNetworkTypes = [];
    let storyCount = props.bubbleData ? props.bubbleData.storyCount : 0;
    let publishedBubbleId =
      this.state.publishValue === DraftState.PUBLISHED &&
      this.state.publishedBubbleId === ''
        ? props.glanceDraftData.bubbleId
        : this.state.publishedBubbleId;
    let publishedRank =
      this.state.publishValue === DraftState.PUBLISHED &&
      this.state.publishedRank === null
        ? props.glanceDraftData.rankInBubble
        : this.state.publishedRank;

    if (cityIds) {
      studioAppConfig.cityGroups.forEach((cityGroup) => {
        for (let city of cityGroup.cities) {
          if (cityIds.includes(city)) {
            cityGroups.push(cityGroup);
            break;
          }
        }
      });
    }

    if (cityIds) {
      cityIds.forEach((city) => {
        const cityObj = studioAppConfig.cities.find((c) => c.id === city);
        if (cityObj) {
          cities.push(cityObj);
        }
      });
    }

    if (carriers) {
      carriers.forEach((carrier) => {
        const carrierObj = studioAppConfig.carrierMetas.find(
          (c) => c.carrierId === carrier,
        );
        if (carrierObj) {
          carrierMetas.push(carrierObj);
        }
      });
    }

    if (segmentIds) {
      segmentIds.forEach((segment) => {
        segments.push(studioAppConfig.sqlSegments.find((s) => s.id == segment));
      });
    }

    if (antiSegmentIds) {
      antiSegmentIds.forEach((segment) => {
        antiSegments.push(
          studioAppConfig.sqlSegments.find((s) => s.id == segment),
        );
      });
    }

    if (get(targeting, 'apps.absent[0]')) {
      negativeTargetingType = 'absent';
      targeting.apps.absent.forEach((target) => {
        const searchItem = studioAppConfig.apps.find((t: any) => t.packageId == target);
        if (searchItem) {
          negativeTargets.push(searchItem);
        }
      });
    } else if (get(targeting, 'apps.anyAbsent[0]')) {
      negativeTargetingType = 'anyAbsent';
      targeting.apps.anyAbsent.forEach((target) => {
        const searchItem = studioAppConfig.apps.find((t: any) => t.packageId == target);
        if (searchItem) {
          negativeTargets.push(searchItem);
        }
      });
    }

    if (get(targeting, 'apps.present[0]')) {
      positiveTargetingType = 'present';
      targeting.apps.present.forEach((target) => {
        const searchItem = studioAppConfig.apps.find((t: any) => t.packageId == target);
        if (searchItem) {
          positiveTargets.push(searchItem);
        }
      });
    } else if (get(targeting, 'apps.anyPresent[0]')) {
      positiveTargetingType = 'anyPresent';
      targeting.apps.anyPresent.forEach((target) => {
        const searchItem = studioAppConfig.apps.find((t: any) => t.packageId == target);
        if (searchItem) {
          positiveTargets.push(searchItem)
        }
      });
    }

    if (type == 4) {
      JerseyRestApiService.getCampaignObjectives()
        .then((response: any) => {
          this.setState({
            ...this.state,
            campaignObjectiveList: response,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // Comment/Uncomment for network Targeting
    if (userNetworkTypes) {
      userNetworkTypes.forEach((element) => {
        selectedNetworkTypes.push({
          value: USER_NETWORK_TYPE_SELECTED[element],
        });
      });
    } else if (!(peek && peek.title)) {
      for (const key in USER_NETWORK_TYPE_SELECTED) {
        selectedNetworkTypes.push({ value: USER_NETWORK_TYPE_SELECTED[key] });
      }
    }

    const sortedBubbles = this.sortBubbleData(type);

    const {
      disable: publishButtonDisability,
      tooltip: publishButtonTooltipText = '',
    } = getPublishButtonAtributes({
      editable,
      glanceDraftData,
      studioAppConfig,
      pristine,
    });

    const beautifulWallpaperFlag = glanceDraftData.isBeautifulWallpaperEnabled;

    const isBeautifulWallpaperEnabled =
      beautifulWallpaperFlag === null || beautifulWallpaperFlag === undefined
        ? true
        : beautifulWallpaperFlag;

    return {
      publisherDatas: publisherDatas,
      categorySource: categorySource,
      categoryMap: categoryMap,
      linkType: linkType,
      dailyWeeklyCapError: false,
      beaconType: BeaconType.RENDER,
      beaconPartner: this.state.beaconPartner || '',
      beaconUrl: this.state.beaconUrl || null,
      beaconError: '',
      minDurationInSecs: 0,
      delayDurationInMillis: null,
      beacons: beacons,
      publisherData: publisherData,
      cities: cities,
      cityGroups: cityGroups,
      citySource: [],
      carrierMetas: carrierMetas,
      carrierSource: [],
      negativeTargets: negativeTargets,
      positiveTargets: positiveTargets,
      negativeTargetingType: negativeTargetingType,
      positiveTargetingType: positiveTargetingType,
      negativeTargetSource: [],
      positiveTargetSource: [],
      segments: segments,
      bubbles: this.state.bubbles,
      filteredBubbles: [],
      antiSegments: antiSegments,
      segmentSource: [],
      publishValue: editMeta.state,
      publishButtonDisability: publishButtonDisability,
      publishButtonTooltipText: publishButtonTooltipText,
      ctaType: peek && peek.ctaType ? peek.ctaType : PropositionType.CTA_URL,
      sortedBubbles: sortedBubbles,
      renderSessionProperties: rendersessionPropertiesMapping(glanceDraftData),
      lsSubTextExceededSize: false,
      lockscreenCtaTextExceededSize: false,
      ctaTextExceededSize: false,
      userNetworkTypes: selectedNetworkTypes,
      campaignObjectiveList: this.state.campaignObjectiveList,
      showTriggerPercentage: false,
      CtaViewExceededHeight: false,
      rankInBubble: rankInBubble ? rankInBubble : 1,
      storyCount: storyCount,
      publishedBubbleId: publishedBubbleId,
      publishedRank: publishedRank,
      showPopover: false,
      allEmojis: [],
      selectedEmoji: {
        emoji: null,
        target: null,
        idx: null,
      },
      chosenEmoji: null,
      hoveredEmoji: null,
      fileUploadError: false,
      sameEmoji: null,
      emojiUploadError: [],
      appOpenNudgeConfig: get(glanceDraftData, 'ociConfigs.appOpenNudgeConfig'),
      appOpenNotificationConfig: get(
        glanceDraftData,
        'ociConfigs.appOpenNotificationConfig',
      ),
      overrideWallpaperMode: !isBeautifulWallpaperEnabled,
      programmaticDetail: get(
        glanceDraftData,
        'Programmatic.programmaticDetail',
      ),
      eu: this.state.eu || get(glanceDraftData, 'eu'),
      valueprop: this.state.valueProp || get(glanceDraftData, 'valueProp'),
      dspCampaignData: get(glanceDraftData, 'dspCampaignData'),
    };
  };

  componentDidUpdate(prevProps: GlanceDraftDetailsProps) {
    if (
      prevProps.detailed !== this.props.detailed &&
      this.props.detailed &&
      this.props.glanceDraftData.peek.tvVideoPeek
    ) {
      this.getEmojiMapping();
    }
  }

  getEmojiMapping = () => {
    if (this.props.glanceDraftData.peek.tvVideoPeek && this.props.detailed) {
      RestService.getDraftEmojiMapping(
        `Bearer ${document.cookie.split('glance-studio-session=')[1]}`,
        this.props.glanceDraftData.draftId,
        (data: EmojiMapping) => {
          if (data[0] && data[0].emojis.length > 0) {
            const emojis = data[0].emojis.sort(
              (a, b) => a.position - b.position,
            );
            this.setState({ ...this.state, currEmojis: emojis });
          }
        },
      );
    }
  };

  fetchBubbleById = () => {
    JerseyRestApiService.getBubbleById(this.props.glanceDraftData.bubbleId)
      .then((response: any) => {
        this.setState({
          ...this.state,
          bubbles: response,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // getAvailableRank = async () => {
  //   if (this.state.rankDetails.length === 0) {
  //     const response: any = await JerseyRestApiService.getAvailableRank(
  //       this.props.glanceDraftData.bubbleId,
  //     );
  //     this.setState({
  //       ...this.state,
  //       rankDetails: response.options.map((item) => ({
  //         ...item,
  //         name: Number(item.name),
  //       })),
  //     });
  //   }
  // };

  sortBubbleData = (type) => {
    const result = this.state.bubbles.filter(
      (bubble) => glanceTypes[type] === glanceTypes[bubble.glanceType],
    );
    return result;
  };

  convertSegmentsToSegmentSources(segments: SqlStudioSegment[]) {
    let segmentSource: SegmentSource[] = [];
    if (!segments) {
      return segmentSource;
    }

    segments.forEach((segment) => {
      segmentSource.push({
        text: segment.name + ' / ' + segment.displayName,
        id: segment.id,
      } as SegmentSource);
    });
    return segmentSource;
  }

  onChange = (key: string, e: React.FormEvent<{}>, newValue: string) => {
    newValue = !newValue || newValue.length == 0 ? null : newValue;
    if (key == 'title') {
      const titleLengthLimit =
        this.props.glanceDraftData.type === GlanceType.SPONSORED
          ? TITLE_LENGTH_LIMIT_SPONSORED
          : TITLE_LENGTH_LIMIT_NON_SPONSORED;
      if (newValue && newValue.length > titleLengthLimit) {
        this.setState({
          ...this.state,
          titleExceededSize: newValue.length,
        });
        newValue = newValue.substr(0, titleLengthLimit);
      } else {
        this.setState({
          ...this.state,
          titleExceededSize: undefined,
        });
      }
    } else if (key == 'shortTitle') {
      if (newValue && newValue.length > SHORT_TITLE_LENGTH_LIMIT) {
        this.setState({
          ...this.state,
          shortTitleExceededSize: newValue.length,
        });
        newValue = newValue.substr(0, SHORT_TITLE_LENGTH_LIMIT);
      } else {
        this.setState({
          ...this.state,
          shortTitleExceededSize: undefined,
        });
      }
    } else if (key == 'summary') {
      if (
        newValue &&
        newValue.length >
          (this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)
      ) {
        this.setState({
          ...this.state,
          summaryExceededSize: newValue.length,
        });
        newValue = newValue.substr(
          0,
          this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT,
        );
      } else {
        this.setState({
          ...this.state,
          summaryExceededSize: undefined,
        });
      }
    } else if (key == 'cheesySummary') {
      if (
        newValue &&
        newValue.length >
          (this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)
      ) {
        this.setState({
          ...this.state,
          cheesySummaryExceededSize: newValue.length,
        });
        newValue = newValue.substr(
          0,
          this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT,
        );
      } else {
        this.setState({
          ...this.state,
          cheesySummaryExceededSize: undefined,
        });
      }
    } else if (key == 'subText') {
      if (newValue && newValue.length > LS_SUBTEXT_LIMIT) {
        this.setState({
          ...this.state,
          lsSubTextExceededSize: true,
        });
        return;
      } else {
        this.setState({
          ...this.state,
          lsSubTextExceededSize: false,
        });
      }
    } else if (key == 'lockscreen_cta_text') {
      if (newValue && newValue.length > CTA_TEXT_LENGTH_LIMIT) {
        this.setState({
          ...this.state,
          lockscreenCtaTextExceededSize: true,
        });
        return;
      } else {
        this.setState({
          ...this.state,
          lockscreenCtaTextExceededSize: false,
        });
      }
    } else if (key == 'cta_text') {
        if (newValue && newValue.length > CTA_TEXT_LENGTH_LIMIT) {
          this.setState({
            ...this.state,
            ctaTextExceededSize: true,
          });
          return;
        } else {
          this.setState({
            ...this.state,
            ctaTextExceededSize: false,
          });
        }
      } else if (key == 'ctaview_height') {
      if (
        newValue &&
        newValue != null &&
        newValue.length > 0 &&
        (Number(newValue) < 10 || Number(newValue) > 100)
      ) {
        this.setState({
          ...this.state,
          CtaViewExceededHeight: true,
        });
        return;
      } else {
        this.setState({
          ...this.state,
          CtaViewExceededHeight: false,
        });
      }
    }
    this.props.onEdit(key, newValue);
  };

  onNudgeConfigUpdate = (key: string, subkey: string, newValue: any) => {
    const finalValue = { ...this.state.appOpenNudgeConfig, [subkey]: newValue };
    if (key == 'ociConfigs') {
      this.setState({
        ...this.state,
        appOpenNudgeConfig: finalValue,
      });
    }
    this.props.onEdit(key, {
      appOpenNotificationConfig: this.state.appOpenNotificationConfig,
      appOpenNudgeConfig: finalValue,
    });
  };

  onNudgeNotificationConfigUpdate = (
    key: string,
    subkey: string,
    newValue: any,
  ) => {
    const finalValue = {
      ...this.state.appOpenNotificationConfig,
      [subkey]: newValue,
    };
    if (key == 'ociConfigs') {
      this.setState({
        ...this.state,
        appOpenNotificationConfig: finalValue,
      });
    }
    this.props.onEdit(key, {
      appOpenNudgeConfig: this.state.appOpenNudgeConfig,
      appOpenNotificationConfig: finalValue,
    });
  };

  addBeacon = () => {
    const { glanceDraftData: draft } = this.props;
    if (this.state.beaconType != null && this.state.beaconUrl) {
      if (!Utils.validURL(this.state.beaconUrl)) {
        this.setState({
          ...this.state,
          beaconError: 'Beacon URL is invalid, please check',
        });
        return '';
      }

      let beacon: Beacon = new Beacon();
      beacon.minDurationInSecs = this.state.minDurationInSecs;
      beacon.url = this.state.beaconUrl.trim();
      beacon.beaconPartner = this.state.beaconPartner;
      let beacons: Beacon[];
      switch (this.state.beaconType) {
        case BeaconType.CTA:
          beacons =
            draft.beacons && draft.beacons.ctaBeacons
              ? draft.beacons.ctaBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              ctaBeacons: beacons,
            },
          });
          break;
        case BeaconType.VIDEO:
          beacons =
            draft.beacons && draft.beacons.videoBeacons
              ? draft.beacons.videoBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              videoBeacons: beacons,
            },
          });
          break;
        case BeaconType.RENDER:
          beacons =
            draft.beacons && draft.beacons.renderBeacons
              ? draft.beacons.renderBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              renderBeacons: beacons,
            },
          });
          break;
        case BeaconType.PEEK:
          beacons =
            draft.beacons && draft.beacons.peekBeacons
              ? draft.beacons.peekBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              peekBeacons: beacons,
            },
          });
          break;
        case BeaconType.LIKE:
          beacons =
            draft.beacons && draft.beacons.likeBeacons
              ? draft.beacons.likeBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              likeBeacons: beacons,
            },
          });
          break;
        case BeaconType.SHARE:
          beacons =
            draft.beacons && draft.beacons.shareBeacons
              ? draft.beacons.shareBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              shareBeacons: beacons,
            },
          });
          break;
        case BeaconType.VIDEO_STARTED:
          beacons =
            draft.beacons && draft.beacons.videoStartedBeacons
              ? draft.beacons.videoStartedBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              videoStartedBeacons: beacons,
            },
          });
          break;
        case BeaconType.HOLD:
          beacons =
            draft.beacons && draft.beacons.holdBeacons
              ? draft.beacons.holdBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              holdBeacons: beacons,
            },
          });
          break;
        case BeaconType.APP_SUBMIT:
          beacons =
            draft.beacons && draft.beacons.appSubmitBeacons
              ? draft.beacons.appSubmitBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              appSubmitBeacons: beacons,
            },
          });
          break;
        case BeaconType.INSTALL_NOW:
          beacons =
            draft.beacons && draft.beacons.installNowBeacons
              ? draft.beacons.installNowBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              installNowBeacons: beacons,
            },
          });
          break;
        case BeaconType.INSTALL_LATER:
          beacons =
            draft.beacons && draft.beacons.installLaterBeacons
              ? draft.beacons.installLaterBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              installLaterBeacons: beacons,
            },
          });
          break;
        case BeaconType.INSTALL_COMPLETE:
          beacons =
            draft.beacons && draft.beacons.installCompleteBeacons
              ? draft.beacons.installCompleteBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              installCompleteBeacons: beacons,
            },
          });
          break;
        case BeaconType.APP_OPEN:
          beacons =
            draft.beacons && draft.beacons.appOpenBeacons
              ? draft.beacons.appOpenBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              appOpenBeacons: beacons,
            },
          });
          break;
        case BeaconType.GLANCE_STARTED:
          beacon.delayDurationInMillis = this.state.delayDurationInMillis;
          beacons =
            draft.beacons && draft.beacons.glanceStartedBeacons
              ? draft.beacons.glanceStartedBeacons
              : [];
          this.setState({
            ...this.state,
            beacons: {
              ...this.state.beacons,
              glanceStartedBeacons: beacons,
            },
          });
          break;
				case BeaconType.PRIVIEW_TAP:
					beacons =
						draft.beacons && draft.beacons.previewTapBeacons
							? draft.beacons.previewTapBeacons
							: [];
					this.setState({
						...this.state,
						beacons: {
							...this.state.beacons,
							previewTapBeacons: beacons,
						},
					});
					break;
				case BeaconType.VIDEO_VIEWED:
					beacons =
						draft.beacons && draft.beacons.videoViewedBeacons
							? draft.beacons.videoViewedBeacons
							: [];
					this.setState({
						...this.state,
						beacons: {
							...this.state.beacons,
							videoViewedBeacons: beacons,
						},
					});
					break;
				case BeaconType.GLANCE_VIEWED:
					beacons =
						draft.beacons && draft.beacons.glanceViewedBeacons
							? draft.beacons.glanceViewedBeacons
							: [];
					this.setState({
						...this.state,
						beacons: {
							...this.state.beacons,
							glanceViewedBeacons: beacons,
						},
					});
					break;
        default:
          break;
      }
      beacons.push(beacon);
      this.props.onEdit(BeaconType[this.state.beaconType], beacons);
    } else {
      this.setState({
        ...this.state,
        beaconError: 'Please enter both type and url',
      });
    }
  };

  removeBeacon = (key: BeaconType, beacon: Beacon[], ind: number) => {
    beacon = beacon.filter((v, i) => i != ind);
    this.props.onEdit(BeaconType[key], beacon);
    switch (key) {
      case BeaconType.CTA:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            ctaBeacons: beacon,
          },
        });
        break;
      case BeaconType.VIDEO:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            videoBeacons: beacon,
          },
        });
        break;
      case BeaconType.RENDER:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            renderBeacons: beacon,
          },
        });
        break;
      case BeaconType.PEEK:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            peekBeacons: beacon,
          },
        });
        break;
      case BeaconType.LIKE:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            likeBeacons: beacon,
          },
        });
        break;
      case BeaconType.SHARE:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            shareBeacons: beacon,
          },
        });
        break;
      case BeaconType.VIDEO_STARTED:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            videoStartedBeacons: beacon,
          },
        });
        break;
      case BeaconType.HOLD:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            holdBeacons: beacon,
          },
        });
        break;
      case BeaconType.APP_SUBMIT:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            appSubmitBeacons: beacon,
          },
        });
        break;
      case BeaconType.INSTALL_NOW:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            installNowBeacons: beacon,
          },
        });
        break;
      case BeaconType.INSTALL_LATER:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            installLaterBeacons: beacon,
          },
        });
        break;
      case BeaconType.INSTALL_COMPLETE:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            installCompleteBeacons: beacon,
          },
        });
        break;
      case BeaconType.APP_OPEN:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            appOpenBeacons: beacon,
          },
        });
        break;
      case BeaconType.GLANCE_STARTED:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            glanceStartedBeacons: beacon,
          },
        });
        break;
      case BeaconType.PRIVIEW_TAP:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            previewTapBeacons: beacon,
          },
        });
        break;
      case BeaconType.VIDEO_VIEWED:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            videoViewedBeacons: beacon,
          },
        });
        break;
      case BeaconType.GLANCE_VIEWED:
        this.setState({
          ...this.state,
          beacons: {
            ...this.state.beacons,
            glanceViewedBeacons: beacon,
          },
        });
        break;
      default:
        break;
    }
  };

  handleBeaconTypeChange = (field, context, value) => {
    this.setState({
      ...this.state,
      beaconType: value,
      minDurationInSecs:
        value == BeaconType.RENDER ||
        value == BeaconType.VIDEO_VIEWED ||
        value == BeaconType.GLANCE_VIEWED
          ? this.state.minDurationInSecs
          : 0,
    });
  };

  handleBeaconUrlChange = (value: string) => {
    this.setState({
      ...this.state,
      beaconUrl: value,
      beaconError: '',
    });
  };

  handleBeaconPartnerChange = (field, context, value) => {
    this.setState({
      ...this.state,
      beaconPartner: value,
    });
  };

  handleMinDurationInSecsChange = (value: number) => {
    this.setState({
      ...this.state,
      minDurationInSecs: value,
    });
  };
  handleDelayDurationInMillis = (value: number) => {
    this.setState({
      ...this.state,
      delayDurationInMillis: value,
    });
  };
  handleImpressionRequired = (e, newValue) => {
    this.setState({
      ...this.state,
      showTriggerPercentage: true,
    });

    if (e.target && e.target.value)
      this.onChange('totalImpressionRequired', e, newValue);
    else this.props.onEdit('impressionCappingData', null);
  };

  handleStoryTypeChange = (event: any, value: any) => {
    this.props.onEdit('storyType', value);
  };

  handleZipCTAChange = async (event: any, value: any) => {
    if(value == 1){
      await this.props.onEdit('ctaUrl', this.props.glanceDraftData.peek.webPeekUrl);
      await this.props.onEdit('webPeekUrl', null);
      !this.props.glanceDraftData.ctaViewConfig.removeTopPadding && await this.props.onEdit('ctaview_hide_toppadding', true);
    } else {
      await this.props.onEdit('webPeekUrl', this.props.glanceDraftData.peek.ctaUrl);
      await this.props.onEdit('ctaUrl', null);
    }
  };

  handleLanguageLimitChange = (event: any, value: any) => {
    if (value > this.state.summaryExceededSize) {
      this.state.summaryExceededSize = undefined;
    }
    if (value > this.state.cheesySummaryExceededSize) {
      this.state.cheesySummaryExceededSize = undefined;
    }
    this.state.summaryLimit = value;
    this.props.onEdit('languageLimit', value);
  };

  handleSkipSummaryChange = () => {
    const { glanceDraftData } = this.props;
    const canSkipSummary =
      glanceDraftData.peek && glanceDraftData.peek.canSkipSummary
        ? false
        : true;
    this.props.onEdit('canSkipSummary', canSkipSummary);
  };

  handleShouldUnlockAppInstalled = (shouldUnlock: boolean) => {
    this.props.onEdit('shouldUnlockAppInstalled', shouldUnlock);
  };

  handleCapChange = (newValue: Number, duration: string) => {
    newValue = newValue && newValue > 0 ? newValue : null;
    this.props.onEdit(duration, newValue);
  };

  handleDailyCapChange = (newValue: Number) =>
    this.handleCapChange(newValue, 'dailyCap');

  handleWeeklyCapChange = (newValue: Number) =>
    this.handleCapChange(newValue, 'weeklyCap');

  handleStickinessChange = (newValue: Number) =>
    this.props.onEdit('stickiness', newValue);

  handleTypeChange = async (field, context, value) => {
    if (value == GlanceType.WALLPAPER || value == GlanceType.SPONSORED) {
      await this.props.onEdit('language', null);
      if (value == GlanceType.SPONSORED && this.props.glanceDraftData.isShareable) {
        await this.props.onEdit('isShareable', false);
      }
      if (
        this.props.glanceDraftData.peek.title &&
        this.props.glanceDraftData.peek.title.length >
          TITLE_LENGTH_LIMIT_SPONSORED
      ) {
        this.onChange(
          'title',
          context,
          this.props.glanceDraftData.peek.title.substr(
            0,
            TITLE_LENGTH_LIMIT_SPONSORED,
          ),
        );
      }
    }
    if (this.state.publishValue != DraftState.PUBLISHED) {
      await this.props.onEdit('type', value);
    }
    if (value != GlanceType.SPONSORED) {
      await this.props.onEdit('isDspCampaign', false);
    }
  };

  handlePriorityChange = (field, context, value) => {
    this.props.onEdit('priority', value);
  };

  handleGlanceContextChange = (field, context, value) => {
    this.props.onEdit('glanceContextType', value);
  };

  handleOmSdkInfoType = (field, context, value) => {
    this.props.onEdit('omSdkInfoType', value);
  };

  handleCampaignObjectiveChange = (field, context, value) => {
    this.props.onEdit('campaignObjective', value);
  };

  handleOciAppSelection = (field, context, value) => {
    const { studioAppConfig, glanceDraftData } = this.props;
    const { apps } = studioAppConfig;
    apps.forEach((appItem: any) => {
      if (appItem.ociTargetable && appItem.packageId === value) {
        if (glanceDraftData.peek.webPeekUrl) {
          let withoutCtaBecaon = { ...appItem, clickBeaconUrl: null };
          this.props.onEdit('ociAppSelection', withoutCtaBecaon);
        } else {
          this.props.onEdit('ociAppSelection', appItem);
        }

        this.setState({
          ...this.state,
          selectedOciAppId: appItem.appId,
        });
      }
    });
  };

  handleAppNotification = (field, targetType, value) => {
    if (targetType === 'notifTemplateId') {
      this.props.onEdit('notifTemplateId', value);
    } else if (targetType === 'd1NotifTemplateId') {
      this.props.onEdit('d1NotifTemplateId', value);
    } else if (targetType === 'ltvNotifTemplateId') {
      this.props.onEdit('ltvNotifTemplateId', value);
    }
  };

  handleCtaTypeChange = (field, context, value) => {
    this.setState({
      ...this.state,
      ctaType: value,
    });
    this.props.onEdit('ctaType', value);
  };

  handleGlanceUserAgeFilterChange = async (value, type) => {
    const selectedDay = value;
    await this.props.onEdit(type, selectedDay);
    if (type === 'startDay') {
      this.props.onEdit('endDay', null);
    }
  };

  handleBeautifulWallpaperChange = (e, value) => {
    this.props.onEdit('isBeautifulWallpaperEnabled', !value);
  };

  checkLanguageCategory = (value) => {
    const { glanceDraftData } = this.props;
    if (glanceDraftData.glanceLanguageId == null || value == null) {
      return true;
    }

    if (
      value === '#tamil_news' &&
      !(glanceDraftData.glanceLanguageId == 'ta')
    ) {
      return false;
    }

    if (
      value === '#telugu_news' &&
      !(glanceDraftData.glanceLanguageId == 'te')
    ) {
      return false;
    }

    return true;
  };

  handleCategoryChange = (chip: any, remove: boolean) => {
    const { glanceDraftData } = this.props;
    if (!remove && !this.checkLanguageCategory(chip.category.id)) {
      return;
    }
    if (this.state.publishValue != DraftState.PUBLISHED) {
      const isSponsored = glanceDraftData.type === GlanceType.SPONSORED;
      const maxCategory = isSponsored
        ? MAX_CATEGORY.SPONSORED
        : MAX_CATEGORY.DEFAULT;
      let newCategories = glanceDraftData.categoryIds;
      if (remove) {
        if (!newCategories) {
          return;
        }
        newCategories = newCategories.filter(function(category) {
          return category != chip.id;
        });
        this.props.onEdit('categoryIds', newCategories);
      } else {
        if (!newCategories) {
          newCategories = [];
        }
        if (newCategories.length >= maxCategory) {
          console.error(`More than ${maxCategory} not allowed`);
          return;
        }
        if (
          newCategories.indexOf(chip.category.id) == -1 &&
          this.state.categoryMap.has(chip.category.id)
        ) {
          // if (chip.category.id == "#plus_plus_random" && newCategories.indexOf('#daily_digest') != -1) {
          //     return
          // }
          newCategories = [...newCategories, chip.category.id];
          this.props.onEdit('categoryIds', newCategories);
        }
      }
    }
  };

  handleValuePropChange = (value: string, region: Region) => {
    this.props.onEdit('valueProp', {vpId: value, region});
    this.setState({
      ...this.state,
      valueProp: value,
    });
  };

  handleEuChange = (value: string | null, region: Region) => {
    this.props.onEdit('eu', {euId: value, region});
    this.setState({
      ...this.state,
      valueProp: null,
    })
  };

  handleCityChange = (chip: CityGroup & String, remove: boolean) => {
    let newCityGroups = this.state.cityGroups;
    let newCities = this.state.cities;
    if (remove) {
      if (!newCityGroups || !newCities) {
        return;
      }
      newCityGroups = newCityGroups.filter(function(cityGroup) {
        let chipStr = chip as String;
        if (cityGroup.groupName === chipStr) {
          // remove from the existing newCities
          newCities = newCities.filter(function(city: City) {
            return !cityGroup.cities.includes(city.id);
          });
          return false;
        } else {
          return true;
        }
      });
    } else {
      if (!newCityGroups) {
        newCityGroups = [];
      }
      if (
        !newCityGroups.find(
          (cityGroup) => cityGroup.groupName == chip.groupName,
        )
      ) {
        const { studioAppConfig } = this.props;
        chip.cities.filter(function(cityId) {
          let city = studioAppConfig.cities.find((city) => city.id == cityId);
          if (city) {
            newCities = [...newCities, city];
          }
        });
        newCityGroups = [...newCityGroups, chip];
      }
    }
    this.props.onEdit(
      'cityIds',
      newCities.map((city) => city.id),
    );
    this.setState({
      ...this.state,
      cities: newCities,
    });
  };

  handleCarrierChange = (chip: any, remove: boolean) => {
    let newCarriers = this.state.carrierMetas;
    if (remove) {
      if (!newCarriers) {
        return;
      }
      newCarriers = newCarriers.filter(function(carrier) {
        return carrier.carrierId != chip;
      });
      this.props.onEdit(
        'carriers',
        newCarriers.map((carrier) => carrier.carrierId),
      );
    } else {
      if (!newCarriers) {
        newCarriers = [];
      }
      if (
        !newCarriers.find((carrier) => carrier.carrierId === chip.carrierId)
      ) {
        newCarriers = [...newCarriers, chip];
        this.props.onEdit(
          'carriers',
          newCarriers.map((carrier) => carrier.carrierId),
        );
      }
    }

    this.setState({
      ...this.state,
      carrierMetas: newCarriers,
    });
  };

  handleBubbleChange = (chip: any, remove: boolean, type: GlanceType) => {
    let newBubbles = this.state.bubbles;
    if (remove) {
      if (!newBubbles) {
        return;
      }
      newBubbles.map((bubble) => bubble.bubbleId === chip);
      if (type == GlanceType.SPONSORED) {
        this.props.onEdit('sponsoredBubbleChange', {
          bubbleId: null,
          adCoefficient: '',
          bucketPriority: null,
          eCpm: '',
          rankInBubble: null,
          rankInBubbleDispay: false,
        });
      } else {
        this.props.onEdit('bubbleId', { bubbleId: null });
      }
    } else {
      if (!newBubbles) {
        newBubbles = [];
      }
      const currentBubble = newBubbles.find(
        (bubble) => bubble.bubbleId == chip.bubbleId,
      );
      if (currentBubble) {
        if (type == GlanceType.SPONSORED) {
          console.log('curr bubble from cardpress', currentBubble);
          let adCoefficient: any = 3;
          let bucketPriority: any = 1;
          let eCpm: any = '';
          let rankInBubble: any = null;

          let adCoefficientDisabled: boolean = false;
          let bucketPriorityDisabled: boolean = false;
          let eCpmDisabled: boolean = false;
          let rankInBubbleDisabled: boolean = false;
          let rankInBubbleDispay: boolean = false;

          if (currentBubble.adCoefficient || currentBubble.adCoefficient == 0) {
            adCoefficient = currentBubble.adCoefficient;
            adCoefficientDisabled = true;
          }
          if (currentBubble.bucketPriority) {
            console.log(
              Utils.getBucketPriority(currentBubble.bucketPriority.toString()),
            );
            bucketPriority = Utils.getBucketPriority(
              currentBubble.bucketPriority.toString(),
            );
            bucketPriorityDisabled = true;
          }
          if (currentBubble.ecpm) {
            eCpm = currentBubble.ecpm;
            eCpmDisabled = true;
          }
          if (currentBubble.storyCount > 0) {
            rankInBubbleDispay = true;
          }
          this.props.onEdit('sponsoredBubbleChange', {
            bubbleId: chip.bubbleId,
            adCoefficient: adCoefficient,
            bucketPriority: bucketPriority,
            eCpm: eCpm,
            adCoefficientDisabled: adCoefficientDisabled,
            bucketPriorityDisabled: bucketPriorityDisabled,
            eCpmDisabled: eCpmDisabled,
            rankInBubble: rankInBubble,
            rankInBubbleDispay: rankInBubbleDispay,
            storyCount: currentBubble.storyCount,
          });
        } else {
          this.props.onEdit('bubbleId', chip);
        }
      }
    }
  };

  handleNegativeTargetChange = (chip: any, remove: boolean, targetingType) => {
    let newNegativeTargets = this.state.negativeTargets;
    if (remove) {
      if (!newNegativeTargets) {
        return;
      }
      newNegativeTargets = newNegativeTargets.filter(function(target) {
        return target.packageId != chip;
      });
      this.props.onEdit('targetingNegative', [
        newNegativeTargets.map((target) => target.packageId),
        this.state.negativeTargetingType,
        NEGATIVE_TARGET_TYPE.filter(
          (type) => type !== this.state.negativeTargetingType,
        ),
      ]);
    } else {
      if (!newNegativeTargets) {
        newNegativeTargets = [];
      }
      if (!newNegativeTargets.find((target) => target.packageId == chip)) {
        newNegativeTargets = [...newNegativeTargets, chip];
        this.props.onEdit('targetingNegative', [
          newNegativeTargets.map((target) => target.packageId),
          this.state.negativeTargetingType,
          NEGATIVE_TARGET_TYPE.filter(
            (type) => type !== this.state.negativeTargetingType,
          ),
        ]);
      }
    }
    this.setState({
      ...this.state,
      negativeTargets: newNegativeTargets,
    });
  };

  handlePositiveTargetChange = (chip: any, remove: boolean, targetingType) => {
    let newPositiveTargets = this.state.positiveTargets;
    if (remove) {
      if (!newPositiveTargets) {
        return;
      }
      newPositiveTargets = newPositiveTargets.filter(function(target) {
        return target.packageId != chip;
      });
      this.props.onEdit('targetingPositive', [
        newPositiveTargets.map((target) => target.packageId),
        this.state.positiveTargetingType,
        POSITIVE_TARGET_TYPE.filter(
          (type) => type !== this.state.positiveTargetingType,
        ),
      ]);
    } else {
      if (!newPositiveTargets) {
        newPositiveTargets = [];
      }
      if (!newPositiveTargets.find((target) => target.packageId == chip)) {
        newPositiveTargets = [...newPositiveTargets, chip];
        this.props.onEdit('targetingPositive', [
          newPositiveTargets.map((target) => target.packageId),
          this.state.positiveTargetingType,
          POSITIVE_TARGET_TYPE.filter(
            (type) => type !== this.state.positiveTargetingType,
          ),
        ]);
      }
    }
    this.setState({
      ...this.state,
      positiveTargets: newPositiveTargets,
    });
  };

  handleSegmentChange = (chip: any, remove: boolean) => {
    const { studioAppConfig } = this.props;
    let newSegments = this.state.segments;
    if (remove) {
      if (!newSegments) {
        return;
      }
      newSegments = newSegments.filter(function(segment) {
        return segment.id != chip;
      });
      this.props.onEdit(
        'segmentIds',
        newSegments.map((seg) => seg.id),
      );
    } else {
      if (!newSegments) {
        newSegments = [];
      }
      if (!newSegments.find((segment) => segment.id == chip.id)) {
        let chipSegment = studioAppConfig.sqlSegments.find(
          (s) => s.id == chip.id,
        );
        newSegments = [...newSegments, chipSegment];
        this.props.onEdit(
          'segmentIds',
          newSegments.map((seg) => seg.id),
        );
      }
    }
    this.setState({
      ...this.state,
      segments: newSegments,
    });
  };

  handleAntiSegmentChange = (chip: any, remove: boolean) => {
    const { studioAppConfig } = this.props;
    let newSegments = this.state.antiSegments;
    if (remove) {
      if (!newSegments) {
        return;
      }
      newSegments = newSegments.filter(function(segment) {
        return segment.id != chip;
      });
      this.props.onEdit(
        'antiSegmentIds',
        newSegments.map((seg) => seg.id),
      );
    } else {
      if (!newSegments) {
        newSegments = [];
      }
      if (!newSegments.find((segment) => segment.id == chip.id)) {
        let chipSegment = studioAppConfig.sqlSegments.find(
          (s) => s.id == chip.id,
        );
        newSegments = [...newSegments, chipSegment];
        this.props.onEdit(
          'antiSegmentIds',
          newSegments.map((seg) => seg.id),
        );
      }
    }
    this.setState({
      ...this.state,
      antiSegments: newSegments,
    });
  };

  onCitySearch = (chip: any) => {
    const { studioAppConfig } = this.props;
    let cityGroups = studioAppConfig.cityGroups;
    let cityGroupSource = cityGroups.filter((cityGroup) => {
      return (
        cityGroup.groupName &&
        cityGroup.groupName.toLowerCase().startsWith(chip.toLowerCase())
      );
    });
    cityGroupSource = cityGroupSource.slice(0, 10).map((item: any) => {
        const newItem = {...item}
        const stateObj = this.props.cityStates && this.props.cityStates.find(e => newItem.cities.indexOf(e.cityId) !== -1);
        if(stateObj && stateObj.stateName){
          newItem.groupName = `${newItem.groupName} - ${stateObj.stateName}`;
        }
        return newItem;
    });
    this.setState({
      ...this.state,
      citySource: cityGroupSource,
    });
  };

  onCarrierSearch = (chip: string) => {
    const { studioAppConfig } = this.props;
    let carrierMetas = studioAppConfig.carrierMetas;
    let carrierSource = carrierMetas.filter((carrier) => {
      return (
        carrier.carrierName &&
        carrier.carrierName.toLowerCase().startsWith(chip.toLowerCase())
      );
    });
    carrierSource = carrierSource.slice(0, 10);

    this.setState({
      ...this.state,
      carrierSource: carrierSource,
    });
  };

  onBubbleSearch = (val: string) => {
    if (val && val.length >= 3) {
      JerseyRestApiService.getSearchBubbles(val)
        .then((response: any) => {
          this.setState({
            ...this.state,
            bubbles: [
              // this.props.bubbleData ? this.props.bubbleData : [],
              ...response,
            ],
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  onNegativeTargetSearch = (chip: any) => {
    const { studioAppConfig } = this.props;
    let negativeTargetSource = studioAppConfig.apps.filter(
      (targetElement: any) => {
        return (
          targetElement &&
          targetElement.name &&
          targetElement.name.toLowerCase().startsWith(chip.toLowerCase())
        );
      },
    );
    negativeTargetSource = negativeTargetSource.slice(0, 10);
    this.setState({
      ...this.state,
      negativeTargetSource,
    });
  };

  onPositiveTargetSearch = (chip: any) => {
    const { studioAppConfig } = this.props;
    let positiveTargetSource = studioAppConfig.apps.filter(
      (targetElement: any) => {
        return (
          targetElement &&
          targetElement.name &&
          targetElement.name.toLowerCase().startsWith(chip.toLowerCase())
        );
      },
    );
    positiveTargetSource = positiveTargetSource.slice(0, 10);
    this.setState({
      ...this.state,
      positiveTargetSource,
    });
  };

  onSegmentSearch = (chip: any) => {
    const { studioAppConfig } = this.props;
    let segments = studioAppConfig.sqlSegments;
    let segmentSourceTemp = this.convertSegmentsToSegmentSources(
      segments.filter((segment) => {
        return (
          (segment.name &&
            segment.name.toLowerCase().indexOf(chip.toLowerCase()) != -1) ||
          (segment.displayName &&
            segment.displayName.toLowerCase().indexOf(chip.toLowerCase()) != -1)
        );
      }),
    );
    segmentSourceTemp = segmentSourceTemp.slice(0, 10);
    this.setState({
      ...this.state,
      segmentSource: segmentSourceTemp,
    });
  };

  handleTagChange = (chip: string, remove: boolean) => {
    const { glanceDraftData } = this.props;
    let newTags = glanceDraftData.tags;
    if (remove) {
      if (!newTags) {
        return;
      }
      newTags = newTags.filter(function(tag) {
        return tag != chip;
      });

      this.props.onEdit('tags', newTags);
    } else {
      if (!newTags) {
        newTags = [];
      }
      if (newTags.indexOf(chip) == -1 && TAG_SOURCE.indexOf(chip) != -1) {
        newTags = [...newTags, chip];
        this.props.onEdit('tags', newTags);
      }
    }
  };

  handleCountryChange = (region: Region, remove: boolean) => {
    const { glanceDraftData } = this.props;
    if (!this.props.editable) {
      return;
    }
    let newRegionList = glanceDraftData.preferedRegions;
    if (remove) {
      if (!newRegionList) {
        return;
      }
      newRegionList = newRegionList.filter(function(item) {
        return item != region;
      });
    } else {
      if (!newRegionList) {
        newRegionList = [];
      }

      if (newRegionList.indexOf(region) == -1) {
        newRegionList = [...newRegionList, region];
      }
    }
    this.props.onEdit('preferedRegions', newRegionList);
  };

  handlePublisherChange = (e: any, index: number, value: string) => {
    const publisherData: PublisherData = value
      ? this.state.publisherDatas.get(value)
      : null;
    this.setState({
      ...this.state,
      publisherData: publisherData,
    });
    this.props.onEdit('publisherData', publisherData);
  };

  handleShouldUnlock = (shouldUnlock: boolean) => {
    this.props.onEdit('shouldUnlock', shouldUnlock);
  };

  handleOpenInBg = (openInBg: boolean) => {
    this.props.onEdit('openInBg', openInBg);
  };

  handleSdkSubscribedCategoriesFilterChange = (field, context, value) => {
    this.props.onEdit('categorySubscriptionStatus', value);
  };

  handleTargetForCategoryChange = (chip: any, remove: boolean) => {
    const { glanceDraftData } = this.props;
    let newCategories = glanceDraftData.targetForCategories;
    if (remove) {
      if (!newCategories) {
        return;
      }
      newCategories = newCategories.filter(function(category) {
        return category != chip.id;
      });

      this.props.onEdit('targetForCategories', newCategories);
    } else {
      if (!newCategories) {
        newCategories = [];
      }

      if (
        newCategories.indexOf(chip.category.id) == -1 &&
        this.state.categoryMap.has(chip.category.id)
      ) {
        newCategories = [...newCategories, chip.category.id];
        this.props.onEdit('targetForCategories', newCategories);
      }
    }
  };

  handleRenderSessionModeChange = (field: string[]) => {
    if (!field) return;
    let renderSessionList = [];
    field.forEach((element) => {
      renderSessionList.push(sessionModeMappingSelected[element]);
    });
    this.props.onEdit('renderSessionProperties', renderSessionList);
  };

  renderSessionListItems = () => {
    const { tvVideoPeek = null } = this.props.glanceDraftData.peek || {};
    if (tvVideoPeek) {
      return GLANCE_TV_LIST_OPTIONS.map((item) => ({ value: item.name }));
    }
    if (
      this.props.glanceDraftData.type === GlanceType.SPONSORED &&
      this.props.cardType !== 2
    ) {
      return SESSION_MODE_LIST_OPTIONS.filter((elem) => {
        if (!isArticle(this.props.glanceDraftData)) {
          return elem.value != 'GAME SPLASH';
        } else return elem;
      });
    } else {
      return SESSION_MODE_LIST_OPTIONS.filter((elem) => {
        if (!isArticle(this.props.glanceDraftData)) {
          return (
            elem.value != 'IN-GAME REWARDED VIDEOS' &&
            elem.value != 'GAME SPLASH'
          );
        } else return elem.value != 'IN-GAME REWARDED VIDEOS';
      });
    }
  };

  handleIsShareable = (isShareable: boolean) => {
    this.props.onEdit('isShareable', isShareable);
  };

  handleHomeScreenWorthy = (homescreenWorthy: boolean) => {
    this.props.onEdit('homescreenWorthy', homescreenWorthy);
  };
  handleServingCappingEnabled = (servingCappingEnabled: boolean) => {
    this.props.onEdit('servingCappingEnabled', servingCappingEnabled);
  };

  handleChildLockFlag = (childlock: boolean) => {
    this.props.onEdit('childlockflag', childlock);
  };

	handleUseUnlockNudge = (childlock: boolean) => {
    this.props.onEdit('useUnlockNudge', childlock);
  };

  handleAllowKeyboard = (allowKeyboard: boolean) => {
    this.props.onEdit('allowKeyboard', allowKeyboard);
  };

  handleAllowNativeKeyboard = (allowNativeKeyboard: boolean) => {
    this.props.onEdit('allowNativeKeyboard', allowNativeKeyboard);
  };

  handleDynamicOverlay = (dynamicOverlay: boolean) => {
    this.props.onEdit('dynamicOverlay', dynamicOverlay);
  };

  handleS2sIntegration = (s2sIntegration: boolean) => {
    this.props.onEdit('s2sIntegration', s2sIntegration);
  };

  handleGPayReadiness = (gPayReadiness: boolean) => {
    this.props.onEdit('gPayReadiness', gPayReadiness);
  };

  handleDspRetargeting = (dspRetargeting: boolean) => {
    this.props.onEdit('dspRetargeting', dspRetargeting);
  };

  handleNativeOverflow = (nativeVideoOverflow: boolean) => {
    this.props.onEdit('nativeVideoOverflow', nativeVideoOverflow);
  };

  handleHardwareAccelerated = (hardwareAccelerated: boolean) => {
    this.props.onEdit('hardwareAccelerated', hardwareAccelerated);
  };

  handleIsShoppable = (isShoppable: boolean) => {
    this.props.onEdit('isShoppable', isShoppable);
  };

  handleLoadAndroidJs = (loadAndroidJs: boolean) => {
    this.props.onEdit('loadAndroidJs', loadAndroidJs);
  };

  handleTargetingTypeChange = (context, targetingType, value) => {
    if (targetingType === 'negativeTargetingType') {
      this.setState({
        ...this.state,
        [targetingType]: value,
        negativeTargets: [],
      });
    } else if (targetingType === 'positiveTargetingType') {
      this.setState({
        ...this.state,
        [targetingType]: value,
        positiveTargets: [],
      });
    }
  };

  handleRankChange = (e: any, field: string, value: number) => {
    this.setState({
      ...this.state,
      rankInBubble: value,
    });
    this.props.onEdit(field, value);
  };

  handleNetworkChange = (field: string[]) => {
    let value = [];
    field.forEach((tuple) => {
      value.push(USER_NETWORK_TYPE[tuple]);
    });
    this.props.onEdit('targetingNetwork', value);
  };

  handleEcpmKeyDown = (e) => {
    if (
      !(
        (e.keyCode > 95 && e.keyCode < 106) ||
        (e.keyCode > 47 && e.keyCode < 58) ||
        e.keyCode == 8 ||
        e.keyCode == 190
      )
    ) {
      e.preventDefault();
    }
  };

  handlectaViewHideTopPadding = (hideCTAViewTopPad: boolean) => {
    this.props.onEdit('ctaview_hide_toppadding', hideCTAViewTopPad);
  };

  handlectaViewHideCrossIcon = (hideCTAViewCrossIcon: boolean) => {
    this.props.onEdit('ctaview_hide_crossicon', hideCTAViewCrossIcon);
  };

  handleBucketPriorityChange = (field, context, value) => {
    console.log(value);
    this.props.onEdit('bucketPriority', value);
  };

  onSubmit = () => {
    this.props.onSave(this.state.autoOpenCta);
  };

  onOverride = () => {
    this.props.onOverride();
  };

  onPublish = () => {
    this.setState({
      ...this.state,
      publishValue: 8,
    });
    this.props.onPublish();
  };

  onRemove = () => {
    this.props.onRemove();
  };

  onPause = (value) => {
    this.props.onPause();
    this.props.onEdit('paused', value);
  };

  checkRankItemStatus = (item: number) => {
    const hasValue = this.state.renderSessionProperties.length > 0;
    const hasLockScreen = this.state.renderSessionProperties.some(
      (item) => item.value === 'LOCKSCREEN',
    );
    if (hasValue && hasLockScreen && item > 1) return true;
    return false;
  };

  handleEmojiClick = (emoji: Emoji, e: any, idx: number) => {
    this.setState({
      ...this.state,
      showPopover: true,
      selectedEmoji: {
        emoji: emoji,
        target: e.currentTarget,
        idx,
      },
    });
    RestService.getEmojis(
      `Bearer ${document.cookie.split('glance-studio-session=')[1]}`,
      (data) => {
        this.setState({
          ...this.state,
          allEmojis: [...data],
        });
      },
    );
  };
  handleReplaceEmoji = (emoji: Emoji) => {
    const newEmojis = [...this.state.currEmojis];
    const idx = this.state.selectedEmoji.idx;
    newEmojis[idx] = emoji;

    this.setState(
      { ...this.state, currEmojis: newEmojis, showPopover: false },
      () => {
        const cache = {};
        let isSameEmoji = false;
        newEmojis.forEach((emoji: Emoji) => {
          if (!cache[emoji.id]) {
            cache[emoji.id] = emoji.id;
          } else {
            this.setState({
              ...this.state,
              sameEmoji: emoji.id,
            });
            isSameEmoji = true;
          }
        });
        if (!isSameEmoji) {
          this.setState({
            ...this.state,
            sameEmoji: null,
          });

          // call the emoji mapping api with payload
          const emojisPayload = this.state.currEmojis.map((emoji, idx) => {
            return {
              id: emoji.id,
              position: idx + 1,
            };
          });
          const payload = {
            glanceId: this.props.glanceDraftData.draftId,
            emojis: emojisPayload,
          };
          RestService.submitEmoji(
            `Bearer ${document.cookie.split('glance-studio-session=')[1]}`,
            payload,
            (data) => console.log('selected', data),
          );
        }
      },
    );
  };

  imageSize = (url): Promise<ImageDimension> => {
    const img = document.createElement('img');
    const promise: Promise<ImageDimension> = new Promise((resolve, reject) => {
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        resolve({ width, height });
      };

      img.onerror = reject;
    });

    img.src = url;

    return promise;
  };

  handleEmojiSize = async (files) => {
    const url = URL.createObjectURL(files);
    const imageDimensions: ImageDimension = await this.imageSize(url);
    return imageDimensions.height === 48 && imageDimensions.width === 48;
  };

  handleDimensionValidation = async (images: any) => {
    const imageFiles = Array.from(images);
    const len = imageFiles.length;
    for (let i = 0; i < len; i++) {
      const isValid = await this.handleEmojiSize(imageFiles[i]);
      if (!isValid) return false;
    }
    return true;
  };

  handleImageSizeValidation = (images: any) => {
    const imageArr = Array.from(images).map((image: any) => {
      if (image.size < 1048576) return true;
      else return false;
    });
    return imageArr.includes(false);
  };

  errorCleanup = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        emojiUploadError: [],
      });
    }, 6500);
  };
  handleFileUploadError = () => {
    this.setState(
      {
        ...this.state,
        emojiUploadError: [
          {
            field: '',
            message:
              'Trying to upload a file of size greater than 1MB which is not permitted',
          },
        ],
      },
      this.errorCleanup,
    );
  };

  handleNumberOfEmojiUpload = (files: any) => {
    if (files.length > 10) {
      this.setState(
        {
          ...this.state,
          emojiUploadError: [
            {
              field: '',
              message: 'Number of files chosen should be less than 10',
            },
          ],
        },
        this.errorCleanup,
      );
      return true;
    } else return false;
  };

  handleFileUpload = async (e: any) => {
    // @ts-ignore
    const newfiles = e.target.files;
    if (this.handleNumberOfEmojiUpload(newfiles)) {
      e.target.value = null;
      return;
    }
    if (this.handleImageSizeValidation(e.target.files)) {
      this.handleFileUploadError();
      e.target.value = null;
      return;
    }

    // const isValid = await this.handleDimensionValidation(e.target.files);
    // if (!isValid) {
    //   this.handleFileUploadError();
    //   return;
    // }

    const payload = new FormData();
    // @ts-ignore
    Array.from(newfiles).map((file) => payload.append('emojis', file));
    // @ts-ignore
    payload.append('emojis', payload);

    RestService.uploadEmoji(
      `Bearer ${document.cookie.split('glance-studio-session=')[1]}`,
      payload,
      (data) => {
        this.setState({
          ...this.state,
          allEmojis: [...this.state.allEmojis, ...data],
          emojiUploadError: [],
          fileUploadError: false,
        });
      },
      (error) => {
        if (error) {
          if (error.title === 'Constraint Violation') {
            this.setState({
              ...this.state,
              emojiUploadError: error.violations,
            });
          } else {
            this.setState({
              ...this.state,
              emojiUploadError: [{ field: '', message: error.detail }],
            });
          }
        }
        this.errorCleanup();
      },
    );
    e.target.value = null;
  };

  render() {
    const { studioAppConfig, glanceDraftData, editable } = this.props;
    console.log('glanceDraftData', glanceDraftData);
    const { publishButtonDisability, publishButtonTooltipText } = this.state;
    const draft = glanceDraftData;
    const isSponsoredGlance = draft.type === GlanceType.SPONSORED;
    const isNativeOCI = this.state.ctaType == PropositionType.APP_INSTALL;
    const userRole = studioAppConfig.currentToken.role;
    const userLifeTimeFilter = glanceDraftData.userLifeTimeFilter || {
      startDay: null,
      endDay: null,
    };
    const startDay = userLifeTimeFilter.startDay || 1;
    const startDays = Array.from(Array(8).keys()).map((stDay) => stDay + 1);
    const endDays = startDays.filter((age) => age >= startDay && age < 8);

    const eCpm = draft.campaignMeta ? draft.campaignMeta.eCpm : null;

    const TITLE_LENGTH_LIMIT = isSponsoredGlance ? TITLE_LENGTH_LIMIT_SPONSORED : TITLE_LENGTH_LIMIT_NON_SPONSORED;

    let leftElements = [];
    let middleElements = [];
    let rightElements = [];

    let peekUrl: string;
    if (draft.peek) {
      if (draft.peek.videoUrl) {
        peekUrl = draft.peek.videoUrl;
      } else if (draft.peek.webPeekUrl) {
        peekUrl = draft.peek.webPeekUrl;
      } else if (draft.peek.ctaUrl) {
        peekUrl = draft.peek.ctaUrl;
      }
    }
    // Any SPONSORED Glance with isShareable is true then making false.
    if (draft && isSponsoredGlance && draft.isShareable) {
      this.props.onEdit('isShareable', false);
    }
    if (
      isSponsoredGlance &&
      isNativeOCI &&
      draft.peek &&
      draft.peek.cta &&
      draft.peek.cta.autoOpenCtaDurationInSecs !== null &&
      !this.state.autoOpenCta
    ) {
      this.setState({ ...this.state, autoOpenCta: true });
    }
    if (
      isNativeOCI &&
      draft.peek &&
      draft.peek.cta &&
      draft.peek.cta.autoOpenCtaDurationInSecs !== null &&
      !isSponsoredGlance
    ) {
      this.setState({ ...this.state, autoOpenCta: false });
      this.props.onEdit('autoOpenCtaDurationInSecs', null);
    }
    if (draft.editMeta.curationReason === null) {
      draft.editMeta.curationReason = 'landing_page_append_utm'
    }
    const { isDspCampaign } = draft.dspCampaignData || { isDspCampaign: false };
    const warningTextGLAM = (
      draft && draft.glamCampaignData ?
      <div style={{
        "color": "lightcoral", /* Change to the desired light maroon color */
        "fontWeight": "bold"
      }}><b>Warning:</b> This glance is GLAM published do not edit in studio.</div> : null
    );
    const title = (
      <TextField
        key="draft_title"
        style={{ ...styles.width100, height: '48px' }}
        hintText="Draft Title"
        value={draft.peek && draft.peek.title ? draft.peek.title : ''}
        disabled={!editable}
        onChange={(e, newValue) => this.onChange('title', e, newValue)}
        errorText={
          this.state.titleExceededSize
            ? 'Maximum allowed size reached ' + TITLE_LENGTH_LIMIT
            : null
        }
        multiLine={true}
        hintStyle={{ bottom: 'calc(100% - 36px)' }}
        rows={2}
        rowsMax={2}
      />
    );
    const shortTitle = (
      <TextField
        key="draft_shortTitle"
        style={{ ...styles.width100, height: '48px' }}
        hintText="Draft Short Title"
        value={draft.peek && draft.peek.shortTitle ? draft.peek.shortTitle : ''}
        disabled={!editable}
        onChange={(e, newValue) => this.onChange('shortTitle', e, newValue)}
        errorText={
          this.state.shortTitleExceededSize
            ? 'Maximum allowed size reached ' + SHORT_TITLE_LENGTH_LIMIT
            : null
        }
        multiLine={true}
        hintStyle={{ bottom: 'calc(100% - 36px)' }}
        rows={2}
        rowsMax={2}
      />
    );
    const curationReason = (
      <TextField
        key="curation_reason"
        style={{ ...styles.width25 }}
        hintText="Curation Reason"
        defaultValue={
          draft.editMeta ? (draft.editMeta.curationReason || 'landing_page_append_utm') : undefined
        }
        disabled={!editable}
        onChange={(e, newValue) => this.onChange('curationReason', e, newValue)}
      />
    );
    const lsSubtext = (
      <TextField
        key="subText"
        style={{ ...styles.width25, marginLeft: '2%' }}
        hintText="LS Subtext"
        defaultValue={
          draft.peek && draft.peek.subText ? draft.peek.subText : undefined
        }
        disabled={!editable}
        onChange={(e, newValue) => this.onChange('subText', e, newValue)}
        errorText={
          this.state.lsSubTextExceededSize
            ? `Maximum allowed size is ${LS_SUBTEXT_LIMIT} Chars`
            : null
        }
      />
    );
    const contentTagsChips = (
        <ChipInput
          key="tags"
          hintText={'Topics'}
          style={{ ...styles.width100, marginTop: '-8px' }}
          value={draft.tags ? draft.tags : []}
          dataSource={TAG_SOURCE}
          onRequestAdd={(chip) => this.handleTagChange(chip, false)}
          onRequestDelete={(chip, index) => this.handleTagChange(chip, true)}
          disabled={!editable}
        />
      );
    const categoriesValue = [];
    if (draft.categoryIds) {
      this.state.categorySource.forEach((categorySource) => {
        if (draft.categoryIds.indexOf(categorySource.category.id) != -1) {
          categoriesValue.push(categorySource);
        }
      });
    }

    const topicName = (
      <TextField
        key="topicName"
        style={{ ...styles.width100, marginTop: '-8px' }}
        defaultValue={draft.topicName ? draft.topicName : undefined}
        hintText="Topic Name"
        disabled={!editable}
        onChange={(e, newValue) => this.onChange('topicName', e, newValue)}
      />
    );

    const categories = (
      <ChipInput
        key="categoryIds"
        hintText={'Category'}
        style={{ ...styles.width100, marginTop: '-8px' }}
        value={categoriesValue}
        dataSource={this.state.categorySource}
        dataSourceConfig={CATEGORY_SOURCE_CONFIG}
        onRequestAdd={(chip) => this.handleCategoryChange(chip, false)}
        onRequestDelete={(chip, index) => this.handleCategoryChange(chip, true)}
        disabled={!editable}
      />
    );

    const eu = (region: Region) => {
      const eus = this.state.allEus.length > 0
        ? this.state.allEus.filter(({country: euCountry}) =>
          euCountry === regionFilters[region])
        : null;
      const eu = this.props.glanceDraftData.eus
        ? this.props.glanceDraftData.eus.filter((eu) => eu.region === region)
        : [];
      return (
        <DropDownMenu
          style={{ ...styles.width33}}
          disabled={!editable}
          value={eu.length > 0 ? eu[0].euId : null}
          onChange={(e, field, value) => this.handleEuChange(value, region)}
        >
          <MenuItem key="null" value={null} primaryText="Select EU" />
          {
            eus ? eus.map(({id, name}) => {
              return (
                <MenuItem key={id} value={id} primaryText={name} />
              )
            }) : null
          }
        </DropDownMenu>
      );
    };

    const valueProp = (region: Region) => {
      const selectedEuObject = this.props.glanceDraftData.eus
        ? this.props.glanceDraftData.eus.filter((eu) => eu.region === region)
        : [];
      const selectedEu = selectedEuObject.length > 0 ? selectedEuObject[0].euId : null;
      const euData = this.state.allEus.length > 0
        ? this.state.allEus.filter(({country, id}) => (country === regionFilters[region] && id === selectedEu))
        : [];
      const valueProps = euData.length > 0 ? euData[0].valueProps: [];
      const valuePropFromDraft = this.props.glanceDraftData.valueProps
        ? this.props.glanceDraftData.valueProps.filter((valueProp) => valueProp.region === region)
        : [];
      const valueProp = valuePropFromDraft.length > 0 ? valuePropFromDraft[0].vpId : null;
      const isValuePropSelected = valueProps.length > 0 ? valueProps.map(vp => vp.id).includes(valueProp) : false;
      const selectedValueProp = isValuePropSelected ? valueProp : null;

      return (
        <DropDownMenu
          style={{ ...styles.width33}}
          value={selectedValueProp}
          disabled={!editable}
          onChange={(e, field, value) => this.handleValuePropChange(value, region)}
        >
          <MenuItem key="null" value={null} primaryText="Select Value Prop" />
          {
            valueProps ? valueProps.map(({id, name}) => {
              return (
                <MenuItem key={id} value={id} primaryText={name} />
              )
            }) : null
          }
        </DropDownMenu>
      );
    };

    const getEuValuePropListItem = (region: Region, index: number) => {
      const countryName = regionNames[region];
      const countryCode = regionFilters[region];
      return countryCode ? (
        <div style={{...styles.euGroup}} key={index}>
          <p style={{...styles.euCountry}}>{countryName}</p>
          {eu(region)}
          {valueProp(region)}
        </div>
      ) : null
    };

    const  euValuePropList = (
      this.props.glanceDraftData.preferedRegions &&
      this.props.glanceDraftData.preferedRegions.length > 0 &&
      this.props.glanceDraftData.preferedRegions.map((region: Region, index) => {
        return (
          getEuValuePropListItem(region, index)
        )
      })
    )

    let sourceCreatorId = null;
    if (
      draft.peek != null &&
      (draft.peek.nativeVideoUrl || draft.peek.webPeekUrl)
    ) {
      sourceCreatorId = (
        <TextField
          key="sourceCreatorId"
          style={{ ...styles.width100, marginTop: '-8px' }}
          defaultValue={draft.sourceCreatorId}
          hintText="Roposo Creator ID"
          disabled={!editable}
          onChange={(e, newValue) =>
            this.onChange('sourceCreatorId', e, newValue)
          }
        />
      );
    }

    const cities = (
      <ChipInput
        key="cities"
        hintText={'Cities'}
        style={{ ...styles.width100, marginTop: '-8px' }}
        value={this.state.cityGroups}
        dataSource={this.state.citySource}
        dataSourceConfig={CITY_SOURCE_CONFIG}
        onUpdateInput={(chip) => this.onCitySearch(chip)}
        onRequestAdd={(chip) => this.handleCityChange(chip, false)}
        onRequestDelete={(chip, index) => this.handleCityChange(chip, true)}
        disabled={!editable}
      />
    );

    const carriers = (
      <ChipInput
        key="carriers"
        hintText={'Carriers'}
        style={{ ...styles.width100, marginTop: '-8px' }}
        value={this.state.carrierMetas}
        dataSource={this.state.carrierSource}
        dataSourceConfig={CARRIER_SOURCE_CONFIG}
        onUpdateInput={(chip: string) => this.onCarrierSearch(chip)}
        onRequestAdd={(chip: string) => this.handleCarrierChange(chip, false)}
        onRequestDelete={(chip: string) => this.handleCarrierChange(chip, true)}
        disabled={!editable}
      />
    );

    const getRankOptions = (count: number) => {
      const rankOptions = [];
      for (let i = 1; i <= count; i++) {
        rankOptions.push(
          <MenuItem
            key={i}
            value={i}
            primaryText={i}
            disabled={this.checkRankItemStatus(i)}
          />,
        );
      }
      return rankOptions;
    };

    const isRankDisabled =
      this.state.rankInBubble > 0 &&
      this.state.publishValue === DraftState.PUBLISHED &&
      draft.bubbleId === this.state.publishedBubbleId;

    const isRankNeeded =
      glanceDraftData.bubbleId &&
      glanceDraftData.type === GlanceType.SPONSORED &&
      ((this.state.bubbles.filter(
        (ele) => ele.bubbleId === glanceDraftData.bubbleId,
      ).length > 0 &&
        this.state.bubbles.filter(
          (ele) => ele.bubbleId === glanceDraftData.bubbleId,
        )[0].storyCount > 0) ||
        this.state.storyCount > 0);

    const rank = isRankNeeded && (
      <DropDownMenu
        disabled={!editable || isRankDisabled}
        value={
          glanceDraftData.bubbleId === this.state.publishedBubbleId
            ? this.state.publishedRank
            : draft.rankInBubble
        }
        key="rank"
        autoWidth={true}
        style={{ ...styles.width50, marginTop: '-8px', width: '50%' }}
        onChange={(e, filed, value) =>
          this.handleRankChange(e, 'rankInBubble', value)
        }
      >
        <MenuItem key="null" value={null} primaryText="Select Rank" />
        {getRankOptions(
          this.state.bubbles.filter((item) => item.bubbleId === draft.bubbleId)
            .length > 0 &&
            this.state.bubbles.filter(
              (item) => item.bubbleId === draft.bubbleId,
            )[0].storyCount,
        )}
      </DropDownMenu>
    );

    const bubbles = (
      <ChipInput
        key="bubbles"
        hintText={'Select Bubble Qualifier'}
        style={
          isRankNeeded
            ? { ...styles.width50, marginTop: '-8px' }
            : { ...styles.width100, marginTop: '-8px' }
        }
        value={this.state.bubbles.filter(
          (item) => item.bubbleId === draft.bubbleId,
        )}
        dataSource={this.state.bubbles}
        dataSourceConfig={BUBBLE_SOURCE_CONFIG}
        onUpdateInput={Utils.debounce(
          (chip) => this.onBubbleSearch(chip),
          1000,
        )}
        onRequestAdd={(chip) =>
          this.handleBubbleChange(chip, false, draft.type)
        }
        onRequestDelete={(chip) =>
          this.handleBubbleChange(chip, true, draft.type)
        }
        disabled={!editable}
      />
    );

    let negativeTargeting = null;
    let positiveTargeting = null;
    let negativeAppList = null;
    let positiveAppList = null;

    negativeTargeting = (
      <DropDownMenu
        value={this.state.negativeTargetingType}
        key="negativeTargetingType"
        style={{ ...styles.width50, marginTop: '-8px' }}
        disabled={!editable}
        onChange={(e, feild, value) =>
          this.handleTargetingTypeChange(e, 'negativeTargetingType', value)
        }
      >
        <MenuItem value={'absent'} primaryText="Absent" />
        <MenuItem value={'anyAbsent'} primaryText="AnyAbsent" />
      </DropDownMenu>
    );

    negativeAppList = (
      <ChipInput
        key="negativeTargetingApp"
        hintText={'Negative Targeting App(s)'}
        style={{ ...styles.width50, marginTop: '-8px' }}
        value={this.state.negativeTargets}
        dataSource={this.state.negativeTargetSource}
        dataSourceConfig={TARGET_SOURCE_CONFIG}
        onUpdateInput={(chip) => this.onNegativeTargetSearch(chip)}
        onRequestAdd={(chip) =>
          this.handleNegativeTargetChange(
            chip,
            false,
            this.state.negativeTargetingType,
          )
        }
        onRequestDelete={(chip, index) =>
          this.handleNegativeTargetChange(
            chip,
            true,
            this.state.negativeTargetingType,
          )
        }
        disabled={!editable}
      />
    );

    positiveTargeting = (
      <DropDownMenu
        value={this.state.positiveTargetingType}
        key="positiveTargetingType"
        disabled={!editable}
        style={{ ...styles.width50, marginTop: '-8px' }}
        onChange={(e, feild, value) =>
          this.handleTargetingTypeChange(e, 'positiveTargetingType', value)
        }
      >
        <MenuItem value={'present'} primaryText="Present" />
        <MenuItem value={'anyPresent'} primaryText="AnyPresent" />
      </DropDownMenu>
    );

    positiveAppList = (
      <ChipInput
        key="positiveTargetingApp"
        hintText={'Positive Targeting App(s)'}
        style={{ ...styles.width50, marginTop: '-8px' }}
        value={this.state.positiveTargets}
        dataSource={this.state.positiveTargetSource}
        dataSourceConfig={TARGET_SOURCE_CONFIG}
        onUpdateInput={(chip) => this.onPositiveTargetSearch(chip)}
        onRequestAdd={(chip) =>
          this.handlePositiveTargetChange(
            chip,
            false,
            this.state.positiveTargetingType,
          )
        }
        onRequestDelete={(chip, index) =>
          this.handlePositiveTargetChange(
            chip,
            true,
            this.state.positiveTargetingType,
          )
        }
        disabled={!editable}
      />
    );

    const networkTargeting = (
      // Comment/Uncomment for network targeting
      <div style={styles.width100} placeholder="Network Targeting">
        <MultiSelectDropdown
          label=""
          placeholder="Network Targeting"
          options={networkTargetingOptions}
          onChange={this.handleNetworkChange}
          selectedValue={this.state.userNetworkTypes}
        />
      </div>
    );

    let segments = null;
    if (!this.state.antiSegments || this.state.antiSegments.length == 0) {
      segments = (
        <ChipInput
          key="segments"
          hintText={'segments'}
          style={{ ...styles.width100, marginTop: '-8px' }}
          value={this.convertSegmentsToSegmentSources(this.state.segments)}
          dataSource={this.state.segmentSource}
          dataSourceConfig={SEGMENT_SOURCE_CONFIG}
          onUpdateInput={(chip) => this.onSegmentSearch(chip)}
          onRequestAdd={(chip) => this.handleSegmentChange(chip, false)}
          onRequestDelete={(chip, index) =>
            this.handleSegmentChange(chip, true)
          }
          disabled={!editable}
        />
      );
    }

    let antiSegments = null;
    if (!this.state.segments || this.state.segments.length == 0) {
      antiSegments = (
        <ChipInput
          key="antiSegments"
          hintText={'NOT in Segments'}
          style={{ ...styles.width100, marginTop: '-8px' }}
          value={this.convertSegmentsToSegmentSources(this.state.antiSegments)}
          dataSource={this.state.segmentSource}
          dataSourceConfig={SEGMENT_SOURCE_CONFIG}
          onUpdateInput={(chip) => this.onSegmentSearch(chip)}
          onRequestAdd={(chip) => this.handleAntiSegmentChange(chip, false)}
          onRequestDelete={(chip, index) =>
            this.handleAntiSegmentChange(chip, true)
          }
          disabled={!editable}
        />
      );
    }

    const attributionSource = (
      <TextField
        key="attribution_source"
        style={styles.width50}
        hintText="Image Attribution"
        defaultValue={
          draft.image && draft.image.attribution
            ? draft.image.attribution.source
            : undefined
        }
        disabled={!editable || this.props.disableAttribution}
        onChange={(e, newValue) =>
          this.onChange('attribution_source', e, newValue)
        }
      />
    );
    const contentTags = (
        <TextField
          key="tags"
          style={styles.width50}
          hintText="Content Tag"
          defaultValue={
            draft.tags && draft.tags[0]
              ? draft.tags[0]
              : undefined
          }
          disabled={!editable}
          onChange={(e, newValue) =>
            this.onChange('tags', e, newValue)
          }
        />
      );
    let peekLink = null;
    if (
      this.state.linkType == 'ctaUrl' ||
      this.state.linkType == 'webPeekUrl'
    ) {
      if (
        this.state.ctaType == PropositionType.APP_INSTALL &&
        !draft.peek.webPeekUrl
      ) {
        peekLink = (
          <div>
            <TextField
              key="InstallLink"
              style={styles.width100}
              hintText="Install Link"
              defaultValue={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallCta &&
                draft.peek.appCta.appInstallCta.url
              }
              disabled={!editable}
              onChange={(e, newValue) =>
                this.onChange('InstallLink', e, newValue)
              }
            />
            <TextField
              key="InstalledLink"
              style={styles.width100}
              hintText="Installed Link"
              defaultValue={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstalledCta &&
                draft.peek.appCta.appInstalledCta.url
              }
              disabled={!editable}
              onChange={(e, newValue) =>
                this.onChange('InstalledLink', e, newValue)
              }
            />
            <TextField
              key="InstallingLink"
              style={styles.width100}
              hintText="Installing Link"
              defaultValue={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallingCta &&
                draft.peek.appCta.appInstallingCta.url
              }
              disabled={!editable}
              onChange={(e, newValue) =>
                this.onChange('InstallingLink', e, newValue)
              }
            />{' '}
          </div>
        );
      } else {
        peekLink = (
          <TextField
            key="PeekLink"
            style={styles.width100}
            hintText="Peek Link"
            defaultValue={peekUrl}
            disabled={!editable}
            onChange={(e, newValue) =>
              this.onChange(this.state.linkType, e, newValue)
            }
          />
        );
      }
    }

    const offlinePeekLink =
      glanceDraftData.type &&
      (glanceDraftData.type === GlanceType.SPONSORED ||
        glanceDraftData.type === GlanceType.STORY) ? (
        <TextField
          key="OfflinePeekLink"
          style={styles.width100}
          hintText="Offline Peek Link"
          disabled={!editable}
          defaultValue={
            glanceDraftData.peek && glanceDraftData.peek.offlinePeekUrl
              ? glanceDraftData.peek.offlinePeekUrl
              : ''
          }
          onChange={(e, newValue) =>
            this.onChange('OfflinePeekLink', e, newValue)
          }
        />
      ) : null;

    let videoCtaUrl = null;
    if (this.state.linkType == 'videoUrl') {
      peekLink = (
        <TextField
          key="PeekLink"
          style={styles.width100}
          hintText="Peek Link"
          defaultValue={
            draft.peek && draft.peek.videoUrl ? draft.peek.videoUrl : ''
          }
          disabled={!editable}
          onChange={(e, newValue) =>
            this.onChange(this.state.linkType, e, newValue)
          }
        />
      );

      if (this.state.ctaType == PropositionType.APP_INSTALL) {
        videoCtaUrl = (
          <div>
            <TextField
              key="InstallLink"
              style={styles.width100}
              hintText="Install Link"
              defaultValue={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallCta &&
                draft.peek.appCta.appInstallCta.url
              }
              disabled={!editable}
              onChange={(e, newValue) =>
                this.onChange('InstallLink', e, newValue)
              }
            />
            <TextField
              key="InstalledLink"
              style={styles.width100}
              hintText="Installed Link"
              defaultValue={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstalledCta &&
                draft.peek.appCta.appInstalledCta.url
              }
              disabled={!editable}
              onChange={(e, newValue) =>
                this.onChange('InstalledLink', e, newValue)
              }
            />
            <TextField
              key="InstallingLink"
              style={styles.width100}
              hintText="Installing Link"
              defaultValue={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallingCta &&
                draft.peek.appCta.appInstallingCta.url
              }
              disabled={!editable}
              onChange={(e, newValue) =>
                this.onChange('InstallingLink', e, newValue)
              }
            />{' '}
          </div>
        );
      } else {
        videoCtaUrl = (
          <TextField
            key="VideoCtaUrl"
            style={styles.width100}
            hintText="VideoCtaUrl"
            defaultValue={
              glanceDraftData.peek && glanceDraftData.peek.videoCtaUrl
                ? glanceDraftData.peek.videoCtaUrl
                : ''
            }
            onChange={(e, newValue) =>
              this.onChange('VideoCtaUrl', e, newValue)
            }
          />
        );
      }
    }

    let isZipCTA: any = null;
    if (draft.type === GlanceType.SPONSORED && this.state.ctaType == PropositionType.CTA_URL && peekUrl && peekUrl.includes('.zip')) {
      if ( this.state.linkType == 'ctaUrl') {
        isZipCTA = 1;
      } else {
        isZipCTA = 0;
      }
    }

    const zipTypes = isZipCTA != null ? (
      <div style={{ margin: '10px 0 9px -8px' }} key="zip_types">
        <RadioButtonGroup
          name="zipTypes"
          style={{ display: 'inline-flex' }}
          defaultSelected={isZipCTA}
          onChange={this.handleZipCTAChange}
        >
          <RadioButton
            style={{
              float: 'left',
              marginLeft: '5px',
              display: 'inline-block',
            }}
            value={0}
            label="Webpeek/Native"
          />
          <RadioButton
            style={{
              float: 'left',
              marginLeft: '10px',
              display: 'inline-block',
            }}
            value={1}
            label="CTAView"
          />
        </RadioButtonGroup>
      </div>
    ) : null;

    let articleCtaUrl = null;
    if (isArticle(this.props.glanceDraftData) && isZipCTA == null) {
      articleCtaUrl = (
        <TextField
          key="articleCtaUrl"
          style={styles.width100}
          hintText="ArticleCtaUrl"
          disabled={!editable}
          defaultValue={
            glanceDraftData.peek && glanceDraftData.peek.articleCtaUrl
              ? glanceDraftData.peek.articleCtaUrl
              : ''
          }
          onChange={(e, newValue) =>
            this.onChange('ArticleCtaUrl', e, newValue)
          }
        />
      );
    }
   
    const AdPersonalisationList = [
      'Drive App Installs',
      'V1_Native OCI',
      'V1_Google Playstore',
      'V1_Remarketing- OCI',
      'V1_Single App OCI',
    ];
    const { peekSourceList, dspPeekSourceList } = this.props;
    const sourceNameList = isDspCampaign ? dspPeekSourceList : peekSourceList;
    let sourceName = null;
    if (
      this.props.glanceDraftData.type === GlanceType.SPONSORED &&
      sourceNameList &&
      sourceNameList.length > 0 &&
      (isDspCampaign ||
        (glanceDraftData.campaignMeta &&
          glanceDraftData.campaignMeta.objective &&
          AdPersonalisationList.includes(
            glanceDraftData.campaignMeta.objective,
          )))
    ) {
      if (
        draft.peek &&
        draft.peek.sourceName &&
        !sourceNameList.includes(draft.peek.sourceName)
      ) {
        this.props.onEdit('source', '');
      }
      sourceName = (
        <DropDownMenu
          key="source_name"
          style={{
            ...styles.width33,
            maxWidth: 'none',
            paddingBottom: '6px',
            float: 'left',
            marginLeft: '-24px',
          }}
          disabled={!editable}
          value={draft.peek ? draft.peek.sourceName : undefined}
          onChange={(e, feild, value) => this.onChange('source', e, value)}
        >
          <MenuItem
            key={'null'}
            value={null}
            disabled={true}
            primaryText="Select Peek Source Name"
          />
          {sourceNameList.map((name, ind) => (
            <MenuItem key={ind} value={name} primaryText={name} />
          ))}
        </DropDownMenu>
      );
    } else {
      sourceName = (
        <TextField
          key="source_name"
          style={styles.width33}
          hintText="Peek Source Name"
          defaultValue={draft.peek ? draft.peek.sourceName : undefined}
          disabled={!editable}
          onChange={(e, newValue) => this.onChange('source', e, newValue)}
        />
      );
    }

    const hearts = (
      <TextField
        key="heartCount"
        style={{ ...styles.width17, ...styles.hearts }}
        hintText="Hearts"
        defaultValue={draft.peek ? draft.peek.heartCount : undefined}
        disabled={!editable}
        onChange={(e, newValue) => this.onChange('hearts', e, newValue)}
        type="number"
      />
    );
    const summary = (
      <TextField
        key="summary"
        style={{ ...styles.width100, marginTop: '-5px' }}
        hintText="Summary"
        value={draft.peek && draft.peek.summary ? draft.peek.summary : ''}
        disabled={!editable}
        multiLine={true}
        rows={5}
        rowsMax={5}
        errorText={
          this.state.summaryExceededSize
            ? 'Maximum allowed size reached ' +
              (this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)
            : null
        }
        onChange={(e, newValue) => this.onChange('summary', e, newValue)}
      />
    );
    const cheesySummary = (
      <TextField
        key="cheesySummary"
        style={{ ...styles.width100, ...styles.marginBottomOnly }}
        hintText="Cheesy Summary"
        value={
          draft.peek && draft.peek.cheesySummary ? draft.peek.cheesySummary : ''
        }
        disabled={!editable}
        multiLine={true}
        rows={5}
        rowsMax={5}
        errorText={
          this.state.cheesySummaryExceededSize
            ? 'Maximum allowed size reached ' +
              (this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)
            : null
        }
        onChange={(e, newValue) => this.onChange('cheesySummary', e, newValue)}
      />
    );
    const glanceType = (
      <div>
        <DropDownMenu
          key="glanceTypeSelector"
          value={glanceDraftData.type ? glanceDraftData.type : GlanceType.STORY}
          onChange={this.handleTypeChange}
          style={{
            ...styles.width50,
            ...styles.marginTopLeft,
            ...styles.marginTopOnly,
          }}
          disabled={!editable || this.state.publishValue === DraftState.PUBLISHED}
        >
          <MenuItem value={GlanceType.STORY} primaryText="Story" />
          <MenuItem value={GlanceType.WALLPAPER} primaryText="Wallpaper" />
          <MenuItem
            value={GlanceType.RESERVED_STORY}
            primaryText="Reserved Story"
          />
          {draft.peek ? (
            <MenuItem value={GlanceType.SPONSORED} primaryText="Sponsored" />
          ) : null}
        </DropDownMenu>
      </div>
    );

    const dspCampaign = this.props.glanceDraftData.type === GlanceType.SPONSORED && (
      <Toggle
        key="isDspCampaign"
        label="Is DSP"
        style={{
          ...styles.width50,
          padding: '6px 0 10px 0',
        }}
        toggled={get(this.state, 'dspCampaignData.isDspCampaign', false)}
        onToggle={(e, newValue) => {
          this.props.onEdit('isDspCampaign', newValue);
        }}
      />
    );

    const priority =
      draft.type != GlanceType.WALLPAPER ? (
        <div>
          {draft.peek && draft.peek.tvVideoPeek ? (
            <div>
              <DropDownMenu
                key="priority_changer"
                value={glanceDraftData.priority}
                onChange={this.handlePriorityChange}
                disabled={!editable}
                style={{
                  ...styles.width50,
                  ...styles.marginTopLeft,
                  ...styles.marginTopOnly,
                }}
              >
                <MenuItem value={9} primaryText="H1" />
                <MenuItem value={8} primaryText="H2" />
                <MenuItem value={7} primaryText="H3" />
                <MenuItem value={6} primaryText="H4" />
                <MenuItem value={5} primaryText="H5" />
                <MenuItem value={4} primaryText="H6" />
                <MenuItem value={3} primaryText="H7" />
                <MenuItem value={2} primaryText="H8" />
                <MenuItem value={1} primaryText="H9" />
                <MenuItem value={0} primaryText="H10" />
              </DropDownMenu>
              {glanceDraftData.priority === draft.priority && (
                <p style={styles.alertMessage}>
                  <FontIcon
                    className="material-icons"
                    color={yellowA700}
                    hoverColor={yellowA700}
                    style={{ fontSize: '24px', marginRight: '8px' }}
                  >
                    info
                  </FontIcon>
                  There are already 1 or more cards running at this priority, by
                  publishing this card, the whole order will move by a step.
                </p>
              )}
            </div>
          ) : (
            <DropDownMenu
              key="priority_changer"
              value={glanceDraftData.priority}
              onChange={this.handlePriorityChange}
              disabled={!editable}
              style={{
                ...styles.width50,
                ...styles.marginTopLeft,
                ...styles.marginTopOnly,
              }}
            >
              <MenuItem value={0} primaryText="Normal Priority" />
              <MenuItem value={1} primaryText="High Priority 1" />
              <MenuItem value={2} primaryText="High Priority 2" />
            </DropDownMenu>
          )}
        </div>
      ) : null;

    const shouldUnlock =
      draft.peek && (draft.peek.ctaUrl || draft.peek.videoCtaUrl) ? (
        <Chip
          style={styles.clickableChip}
          key={'peek_cta'} //labelColor={draft.peek.cta.shouldUnlock  ? blue300 : null}
          backgroundColor={draft.peek.shouldUnlock ? blue300 : null}
          onTouchTap={() => {
            this.handleShouldUnlock(!draft.peek.shouldUnlock);
          }}
        >
          {draft.peek.shouldUnlock ? 'CTA After Unlock' : 'CTA On Lockscreen'}
        </Chip>
      ) : (
        <Chip style={styles.clickableChip} key={'peek_cta'}>
          No Peek-CTA
        </Chip>
      );

    let openInBgCheck =
      draft.peek &&
      (draft.peek.ctaUrl || draft.peek.videoCtaUrl) &&
      draft.peek.cta &&
      draft.peek.cta.openUrlCta
        ? draft.peek.cta.openUrlCta.openInBg
        : false;

    const openInBg = (
      <Chip
        style={styles.clickableChip}
        key={'open_in_bg'}
        backgroundColor={openInBgCheck ? blue300 : null}
        onTouchTap={() => {
          this.handleOpenInBg(!openInBgCheck);
        }}
      >
        {openInBgCheck ? 'Open In Background' : "Don't Open In Background"}
      </Chip>
    );

    const storyType = (
      <div style={{ margin: '0 0 0 -6px' }} key="story_type">
        <RadioButtonGroup
          name="storyType"
          style={{ display: 'inline-flex' }}
          defaultSelected={draft.storyType}
          onChange={this.handleStoryTypeChange}
        >
          <RadioButton
            style={{
              float: 'left',
              marginLeft: '5px',
              display: 'inline-block',
            }}
            value={StoryType.FEATURE}
            label="Feature"
            disabled={!editable}
          />
          <RadioButton
            style={{
              float: 'left',
              marginLeft: '10px',
              display: 'inline-block',
            }}
            value={StoryType.NEWS}
            label="News"
            disabled={!editable}
          />
          <RadioButton
            style={{
              float: 'left',
              marginLeft: '10px',
              display: 'inline-block',
            }}
            value={StoryType.GLANCETV}
            label="GlanceTV"
            disabled={!editable}
          />
        </RadioButtonGroup>
      </div>
    );

    const stickiness = (
      <TextField
        key="stickiness"
        style={{ ...styles.width33, height: '56px' }}
        defaultValue={draft.stickinessCount}
        hintText="Stickiness"
        type="number"
        onChange={(e, newValue) =>
          this.handleStickinessChange(Number(newValue))
        }
      />
    );

    const languageLimit =
      draft && draft.peek ? (
        <div style={{ margin: '10px 0 9px -8px' }} key="language_limit">
          <RadioButtonGroup
            name="languageLimit"
            style={{ display: 'inline-flex' }}
            defaultSelected={
              draft && draft.peek ? draft.peek.summaryLimit : null
            }
            onChange={this.handleLanguageLimitChange}
          >
            <RadioButton
              style={{
                float: 'left',
                marginLeft: '5px',
                display: 'inline-block',
              }}
              value={LanguageLimit.ENG}
              label="English"
            />
            <RadioButton
              style={{
                float: 'left',
                marginLeft: '10px',
                display: 'inline-block',
              }}
              value={LanguageLimit.HINDI}
              label="Hindi"
            />
          </RadioButtonGroup>
        </div>
      ) : null;

    const sdkSubscribedCategoriesFilter = (
      <div
        style={{ float: 'left', marginTop: '2px' }}
        key="sdk_subcribed_filter"
      >
        <DropDownMenu
          value={
            glanceDraftData.categorySubscriptionStatus
              ? glanceDraftData.categorySubscriptionStatus
              : null
          }
          onChange={this.handleSdkSubscribedCategoriesFilterChange}
          disabled={!editable}
          style={{ marginLeft: '-24px' }}
        >
          <MenuItem
            key="null"
            value={null}
            primaryText="SDK Subscribed Categories"
          />
          <MenuItem
            key={SubscriptionStatus.ANY}
            value={SubscriptionStatus.ANY}
            primaryText="At Least 1"
          />
          <MenuItem
            key={SubscriptionStatus.NONE}
            value={SubscriptionStatus.NONE}
            primaryText="None"
          />
        </DropDownMenu>
      </div>
    );

    const categoryMap = [];
    studioAppConfig.categories.forEach((category) => {
      categoryMap.push(
        <MenuItem
          key={category.id}
          value={category.id}
          primaryText={category.displayName}
        />,
      );
    });

    const targetForCategoriesValue = [];
    if (draft.targetForCategories) {
      this.state.categorySource.forEach((categorySource) => {
        if (
          draft.targetForCategories.indexOf(categorySource.category.id) != -1
        ) {
          targetForCategoriesValue.push(categorySource);
        }
      });
    }

    const targetForCategory = (
      <ChipInput
        key="targetForCategories"
        hintText={'Not Subscribed to Categories'}
        style={{ ...styles.width100, marginTop: '-8px' }}
        value={targetForCategoriesValue}
        dataSource={this.state.categorySource}
        dataSourceConfig={CATEGORY_SOURCE_CONFIG}
        onRequestAdd={(chip) => this.handleTargetForCategoryChange(chip, false)}
        onRequestDelete={(chip, index) =>
          this.handleTargetForCategoryChange(chip, true)
        }
        disabled={!editable}
      />
    );

    const publishers = [];
    this.state.publisherDatas.forEach(
      (publisherData: PublisherData, id: string) => {
        publishers.push(
          <MenuItem
            key={publisherData.id}
            value={publisherData.id}
            primaryText={publisherData.displayName}
          />,
        );
      },
    );

    const publisherOptions = (
      <DropDownMenu
        data-store={draft.publisherData}
        value={draft.publisherData ? draft.publisherData.id : null}
        onChange={this.handlePublisherChange}
        key="publisher"
        disabled={!editable}
        style={{ ...styles.width33, marginLeft: '-23px' }}
      >
        <MenuItem key="null" value={null} primaryText="Select Publisher" />
        {publishers}
      </DropDownMenu>
    );

    let ctaText = null;
    let afterOciAppSelect = null;
    if (this.state.ctaType == PropositionType.APP_INSTALL) {
      const menuItems = this.props.studioAppConfig.notificationTemplates
        .filter((template) => {
          if (this.state.selectedOciAppId) {
            return template.appId == this.state.selectedOciAppId;
          } else if (
            glanceDraftData.peek &&
            glanceDraftData.peek.appCta &&
            glanceDraftData.peek.appCta.appInstallMeta &&
            glanceDraftData.peek.appCta.appInstallMeta.appId
          ) {
            return (
              template.appId == glanceDraftData.peek.appCta.appInstallMeta.appId
            );
          }
        })
        .map((item) => {
          return (
            <MenuItem
              key={item.notifTemplateId}
              value={item.notifTemplateId}
              primaryText={item.notifQualifier}
            />
          );
        });

      ctaText = draft.peek && draft.peek.webPeekUrl && (
        <TextField
          key="cta_text"
          style={styles.width25}
          hintText="CTA Text"
          value={draft.peek && draft.peek.cta ? draft.peek.cta.text : ''}
          disabled={!editable}
          onChange={(e, newValue) => this.onChange('cta_text', e, newValue)}
          errorText={
            this.state.ctaTextExceededSize && true
              ? `Maximum allowed size is ${CTA_TEXT_LENGTH_LIMIT}`
              : null
          }
        />
      );
      afterOciAppSelect = (
        <div>
          {draft.peek && !draft.peek.webPeekUrl && (
            <div>
              {/* <TextField
                key="InstallCtaText"
                style={styles.width100}
                hintText="Install Cta Text"
                defaultValue={
                  draft.peek &&
                  draft.peek.appCta &&
                  draft.peek.appCta.appInstallCta &&
                  draft.peek.appCta.appInstallCta.ctaDisplay &&
                  draft.peek.appCta.appInstallCta.ctaDisplay.ctaDisplayText &&
                  draft.peek.appCta.appInstallCta.ctaDisplay.ctaDisplayText.text
                    ? draft.peek.appCta.appInstallCta.ctaDisplay.ctaDisplayText
                        .text
                    : undefined
                }
                disabled={!editable}
                onChange={(e, newValue) =>
                  this.onChange('InstallCtaText', e, newValue)
                }
              /> */}
              <TextField
                key="InstalledCtaText"
                style={styles.width100}
                hintText="Installed Cta Text"
                defaultValue={
                  draft.peek &&
                  draft.peek.appCta &&
                  draft.peek.appCta.appInstalledCta &&
                  draft.peek.appCta.appInstalledCta.ctaDisplay &&
                  draft.peek.appCta.appInstalledCta.ctaDisplay.ctaDisplayText &&
                  draft.peek.appCta.appInstalledCta.ctaDisplay.ctaDisplayText
                    .text
                    ? draft.peek.appCta.appInstalledCta.ctaDisplay
                        .ctaDisplayText.text
                    : undefined
                }
                disabled={!editable}
                onChange={(e, newValue) =>
                  this.onChange('InstalledCtaText', e, newValue)
                }
              />
              <TextField
                key="AppName"
                style={styles.width100}
                hintText="App Name"
                defaultValue={
                  draft.peek &&
                  draft.peek.appCta &&
                  draft.peek.appCta.appInstallMeta
                    ? draft.peek.appCta.appInstallMeta.appName
                    : undefined
                }
                disabled={!editable}
                onChange={(e, newValue) =>
                  this.onChange('AppName', e, newValue)
                }
              />
            </div>
          )}
          {/* <TextField
            key="InstallingCtaText"
            style={styles.width100}
            hintText="Installing Cta Text"
            defaultValue={
              draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallingCta &&
                draft.peek.appCta.appInstallingCta.ctaDisplay &&
                draft.peek.appCta.appInstallingCta.ctaDisplay.ctaDisplayText &&
                draft.peek.appCta.appInstallingCta.ctaDisplay.ctaDisplayText.text
                ? draft.peek.appCta.appInstallingCta.ctaDisplay.ctaDisplayText
                  .text
                : undefined
            }
            disabled={!editable}
            onChange={(e, newValue) =>
              this.onChange('InstallingCtaText', e, newValue)
            }
          /> */}
          {/* <TextField
            key="AppPackageName"
            style={styles.width100}
            hintText="App Package Name"
            defaultValue={
              draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallMeta
                ? draft.peek.appCta.appInstallMeta.packageName
                : undefined
            }
            disabled={!editable}
            onChange={(e, newValue) =>
              this.onChange('AppPackageName', e, newValue)
            }
          /> */}

          <div>
            <DropDownMenu
              value={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallMeta &&
                draft.peek.appCta.appInstallMeta.notifTemplateId
                  ? draft.peek.appCta.appInstallMeta.notifTemplateId
                  : ''
              }
              onChange={(e, feild, value) =>
                this.handleAppNotification(e, 'notifTemplateId', value)
              }
              disabled={!editable}
              style={{ ...styles.width50, ...styles.marginTopLeft }}
            >
              <MenuItem value={''} primaryText="Select D0 Template" />

              {menuItems}
            </DropDownMenu>
            <DropDownMenu
              value={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallMeta &&
                draft.peek.appCta.appInstallMeta.d1NotifTemplateId
                  ? draft.peek.appCta.appInstallMeta.d1NotifTemplateId
                  : ''
              }
              disabled={!editable}
              onChange={(e, feild, value) =>
                this.handleAppNotification(e, 'd1NotifTemplateId', value)
              }
              style={{ ...styles.width50, ...styles.marginTopLeft }}
            >
              <MenuItem value={''} primaryText="Select D1 Template" />

              {menuItems}
            </DropDownMenu>
            <DropDownMenu
              value={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstallMeta &&
                draft.peek.appCta.appInstallMeta.ltvNotifTemplateId
                  ? draft.peek.appCta.appInstallMeta.ltvNotifTemplateId
                  : ''
              }
              disabled={!editable}
              onChange={(e, feild, value) =>
                this.handleAppNotification(e, 'ltvNotifTemplateId', value)
              }
              style={{ ...styles.width50, ...styles.marginTopLeft }}
            >
              <MenuItem value={''} primaryText="Select LTV Template" />

              {menuItems}
            </DropDownMenu>
          </div>
          {!draft.peek.webPeekUrl && (
            <Chip
              style={styles.clickableChip}
              key={'should_unlock_installed'}
              backgroundColor={
                draft.peek &&
                draft.peek.appCta &&
                draft.peek.appCta.appInstalledCta &&
                draft.peek.appCta.appInstalledCta.shouldUnlock
                  ? blue300
                  : null
              }
              onTouchTap={() => {
                this.handleShouldUnlockAppInstalled(
                  !draft.peek.appCta.appInstalledCta.shouldUnlock,
                );
              }}
            >
              {draft.peek.appCta.appInstalledCta.shouldUnlock
                ? 'App Installed CTA After Unlock'
                : 'App Installed CTA On Lockscreen'}
            </Chip>
          )}
        </div>
      );
    } else {
      ctaText = (
        <TextField
          key="cta_text"
          style={{ ...styles.width20, marginLeft: '1%' }}
          hintText="CTA Text"
          value={draft.peek && draft.peek.cta ? draft.peek.cta.text : ''}
          disabled={!editable}
          onChange={(e, newValue) => this.onChange('cta_text', e, newValue)}
          errorText={
            this.state.ctaTextExceededSize && true
              ? `Maximum allowed size is ${CTA_TEXT_LENGTH_LIMIT}`
              : null
          }
        />
      );
    }

    const lockscreenCtaText = (
      <TextField
        key="lockscreen_cta_text"
        style={{ ...styles.width25, marginLeft: '2%' }}
        hintText="LS CTA Text"
        value={
          draft.peek && draft.peek.lockscreenCtaText
            ? draft.peek.lockscreenCtaText
            : ''
        }
        disabled={!editable}
        onChange={(e, newValue) =>
          this.onChange('lockscreen_cta_text', e, newValue)
        }
        errorText={
          this.state.lockscreenCtaTextExceededSize
            ? `Maximum allowed size is ${CTA_TEXT_LENGTH_LIMIT}`
            : null
        }
      />
    );

    const CtaViewConfigHeight = draft.type === GlanceType.SPONSORED && isZipCTA == 0 ? null : (
      <TextField
        key="ctaview_height"
        style={{ ...styles.width25 }}
        defaultValue={
          draft.ctaViewConfig && draft.ctaViewConfig.height
            ? draft.ctaViewConfig.height
            : null
        }
        hintText="CTA View height"
        disabled={!editable}
        type="number"
        onChange={(e, newValue) => this.onChange('ctaview_height', e, newValue)}
        errorText={
          this.state.CtaViewExceededHeight ? `Allowed range 10-100` : null
        }
      />
    );

    const ctaViewHideTopPadding = draft.type === GlanceType.SPONSORED && isZipCTA == 0 ? null :(
      <Chip
        style={{ ...styles.clickableChip, marginLeft: '10px' }}
        key={'ctaview_hide_toppadding'}
        backgroundColor={
          draft.ctaViewConfig && draft.ctaViewConfig.removeTopPadding
            ? blue300
            : null
        }
        onTouchTap={() => {
          this.handlectaViewHideTopPadding(
            !(draft.ctaViewConfig && draft.ctaViewConfig.removeTopPadding),
          );
        }}
      >
        {draft.ctaViewConfig && draft.ctaViewConfig.removeTopPadding
          ? 'CTA View hide top padding'
          : 'CTA View show top padding'}
      </Chip>
    );

    const ctaViewHideCrossIcon = draft.type === GlanceType.SPONSORED && isZipCTA == 0 ? null :(
      <Chip
        style={{ ...styles.clickableChip, marginLeft: '10px' }}
        key={'ctaview_hide_crossicon'}
        backgroundColor={
          draft.ctaViewConfig && draft.ctaViewConfig.hideCrossIcon
            ? blue300
            : null
        }
        onTouchTap={() => {
          this.handlectaViewHideCrossIcon(
            !(draft.ctaViewConfig && draft.ctaViewConfig.hideCrossIcon),
          );
        }}
      >
        {draft.ctaViewConfig && draft.ctaViewConfig.hideCrossIcon
          ? 'CTA View hide cross icon'
          : 'CTA View show cross icon'}
      </Chip>
    );

    const canSkipSummary = draft.peek ? (
      <Chip
        style={{ ...styles.clickableChip, margin: '0 20px 0 -2px' }}
        key={'skip_summary_changer'}
        labelColor={draft.peek.canSkipSummary ? skipSummaryLabelColor : null}
        backgroundColor={
          draft.peek.canSkipSummary ? skipSummaryBackgroundColor : null
        }
        onTouchTap={() => {
          this.handleSkipSummaryChange();
        }}
      >
        {draft.peek.canSkipSummary ? 'Can skip summary' : 'Cannot skip summary'}
      </Chip>
    ) : null;

    const isFcapsDisabled = () => {
      return (
        glanceDraftData.bubbleId &&
        draft.type === GlanceType.SPONSORED &&
        (this.state.storyCount > 0 ||
          (this.state.bubbles.filter((item) => item.bubbleId === draft.bubbleId)
            .length > 0 &&
            this.state.bubbles.filter(
              (item) => item.bubbleId === draft.bubbleId,
            )[0].storyCount > 0)) &&
        this.state.rankInBubble !== 1
      );
    };

    const dailyCap = (
      <TextField
        disabled={isFcapsDisabled()}
        key="dailyCap"
        style={{ width: '33%', marginTop: '-8px' }}
        value={
          draft.frequencyCaps && draft.frequencyCaps.daily
            ? draft.frequencyCaps.daily
            : ''
        }
        hintText="Daily Cap"
        type="number"
        onChange={(e, newValue) => this.handleDailyCapChange(Number(newValue))}
      />
    );

    const weeklyCap = (
      <TextField
        disabled={isFcapsDisabled()}
        key="weeklyCap"
        style={{ width: '33%', marginTop: '-8px', float: 'right' }}
        value={
          draft.frequencyCaps && draft.frequencyCaps.weekly
            ? draft.frequencyCaps.weekly
            : ''
        }
        hintText="Weekly Cap"
        type="number"
        onChange={(e, newValue) => this.handleWeeklyCapChange(Number(newValue))}
      />
    );

    const sessionMode = (
      <div>
        <MultiSelectDropdown
          label=""
          placeholder="Session Mode"
          options={this.renderSessionListItems()}
          onChange={this.handleRenderSessionModeChange}
          selectedValue={this.state.renderSessionProperties}
          key="renderSessionProperties"
          isDisabled={true}
          rankInBubble={this.state.rankInBubble}
        />
      </div>
    );

    const OCIAppList = () => {
      let selectedValue: AppInstallMeta = null;
      if (glanceDraftData.peek && glanceDraftData.peek.appCta) {
        selectedValue = JSON.parse(
          JSON.stringify(glanceDraftData.peek.appCta.appInstallMeta),
        );
      } else {
        return null;
      }

      const { studioAppConfig } = this.props;

      const { apps } = studioAppConfig;
      const filteredAppList = apps.filter((appItem: any) => {
        return (
          appItem.logoUrl &&
          appItem.category &&
          appItem.title &&
          appItem.ociTargetable
        );
      });

      filteredAppList.sort((app1: any, app2: any) =>
        app1.name.toLowerCase().localeCompare(app2.name.toLowerCase()),
      );
      return (
        <div>
          <DropDownMenu
            value={selectedValue && selectedValue.packageName}
            onChange={this.handleOciAppSelection}
            disabled={!editable}
            style={{ ...styles.width50, ...styles.marginTopLeft }}
          >
            <MenuItem value={null} primaryText="Select OCI App" />
            {filteredAppList.map((appItem: any) => {
              return (
                <MenuItem
                  key={`endDay-${appItem.appId}`}
                  value={appItem.packageId}
                  primaryText={appItem.name}
                />
              );
            })}
          </DropDownMenu>
        </div>
      );
    };

    let AutoOpenCta, AutoOpenCtaDurationInSecs;
      AutoOpenCta = (
        <Toggle
          key="autoOpenCta"
          label="Auto Open CTA"
          style={styles.width50}
          toggled={get(this.state, 'autoOpenCta', false)}
          onToggle={(e, newValue) => {
            this.setState({ ...this.state, autoOpenCta: newValue });
            if (!newValue) {
              this.props.onEdit('autoOpenCtaDurationInSecs', null);
            }
          }}
        />
      );
      AutoOpenCtaDurationInSecs = this.state.autoOpenCta && (
        <TextField
          key="autoOpenCtaDurationInSecs"
          style={styles.width45}
          hintText="CTA Duration In Secs"
          type="number"
          defaultValue={
            draft.peek.cta && draft.peek.cta.autoOpenCtaDurationInSecs !== null
              ? draft.peek.cta.autoOpenCtaDurationInSecs
              : undefined
          }
          onChange={(e, newValue) =>
            this.props.onEdit('autoOpenCtaDurationInSecs', newValue)
          }
        />
      );

    const AutoOpenWrapper = isNativeOCI && isSponsoredGlance && (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 1,
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          height: '48px'
        }}
      >
        {AutoOpenCta}
        {AutoOpenCtaDurationInSecs}
      </div>
    );

    const NudgeWebUrl = (
      <TextField
        key="weburl"
        style={styles.width100}
        hintText="Web Url"
        type="string"
        value={get(this.state, 'appOpenNudgeConfig.weburl', '')}
        onChange={(e, newValue) =>
          this.onNudgeConfigUpdate('ociConfigs', 'weburl', newValue)
        }
      />
    );

    const NudgeCtaText = (
      <TextField
        key="nudgeCtaText"
        style={styles.width100}
        hintText="Nudge Cta Text"
        type="string"
        value={get(this.state, 'appOpenNudgeConfig.nudgeCtaText', '')}
        onChange={(e, newValue) =>
          this.onNudgeConfigUpdate('ociConfigs', 'nudgeCtaText', newValue)
        }
      />
    );

    const NudgeDescription = (
      <TextField
        key="nudgeDescription"
        style={styles.width100}
        hintText="Nudge Description"
        type="string"
        value={get(this.state, 'appOpenNudgeConfig.nudgeDescription', '')}
        onChange={(e, newValue) =>
          this.onNudgeConfigUpdate('ociConfigs', 'nudgeDescription', newValue)
        }
      />
    );

    const NudgeMode = (
      <TextField
        key="nudgeMode"
        type="number"
        style={styles.width50}
        hintText="Nudge Mode"
        value={get(this.state, 'appOpenNudgeConfig.nudgeMode', '')}
        onChange={(e, newValue) =>
          this.onNudgeConfigUpdate('ociConfigs', 'nudgeMode', newValue)
        }
      />
    );

    const ShowNudge = (
      <Toggle
        key="showNudge"
        label="Show Nudge"
        style={styles.width50}
        toggled={get(this.state, 'appOpenNudgeConfig.showNudge', '')}
        onToggle={(e, newValue) =>
          this.onNudgeConfigUpdate('ociConfigs', 'showNudge', newValue)
        }
      />
    );

    const isHardWareAcceleration = (
      <Toggle
        key="hwe"
        label="Is HardWare Acceleration"
        style={styles.width50}
        toggled={get(this.state, 'appOpenNudgeConfig.hwe', '')}
        onToggle={(e, newValue) =>
          this.onNudgeConfigUpdate('ociConfigs', 'hwe', newValue)
        }
      />
    );

    const isBeautifulWallpaper = (() => {
      const showBeautifulWallpaperFlag = Utils.getEnvDetails() !== 'prod';

      return (
        <Tooltip
          content="Turning ON will override beautiful wallpapers / Wallpaper Mode i.e. the image in this glance will be used on lock screen instead of the beautiful wallpaper"
          styles={{
            ...styles.tooltipStyle,
            wrapper: {
              ...styles.tooltipStyle.wrapper,
              ...styles.width100,
              display: `${showBeautifulWallpaperFlag ? 'table' : 'none'}`, // TODO : Change the display property to 'table' to show this button in UI in prod when the feature is   available
            },
          }}
        >
          <Toggle
            key="overrideWallpaperMode"
            label="Override Wallpaper Mode"
            style={{ ...styles.width50 }}
            toggled={this.state.overrideWallpaperMode}
            onToggle={this.handleBeautifulWallpaperChange}
          />
        </Tooltip>
      );
    })();

    const notificationEnabled = (
      <Toggle
        key="enabled"
        label="Notification Enabled"
        style={styles.width50}
        toggled={get(this.state, 'appOpenNotificationConfig.enabled', '')}
        onToggle={(e, newValue) =>
          this.onNudgeNotificationConfigUpdate(
            'ociConfigs',
            'enabled',
            newValue,
          )
        }
      />
    );

    const notificationIconUrl = (
      <TextField
        key="iconUrl"
        type="string"
        style={styles.width100}
        hintText="Icon URL"
        value={get(this.state, 'appOpenNotificationConfig.iconUrl', '')}
        onChange={(e, newValue) =>
          this.onNudgeNotificationConfigUpdate(
            'ociConfigs',
            'iconUrl',
            newValue,
          )
        }
      />
    );

    const notificationTitle = (
      <TextField
        key="Title"
        type="string"
        style={styles.width100}
        hintText="Notification Title"
        value={get(this.state, 'appOpenNotificationConfig.title', '')}
        onChange={(e, newValue) =>
          this.onNudgeNotificationConfigUpdate('ociConfigs', 'title', newValue)
        }
      />
    );

    const notificationDescription = (
      <TextField
        key="description"
        type="string"
        style={styles.width100}
        hintText="Notification Description"
        value={get(this.state, 'appOpenNotificationConfig.description', '')}
        onChange={(e, newValue) =>
          this.onNudgeNotificationConfigUpdate(
            'ociConfigs',
            'description',
            newValue,
          )
        }
      />
    );

    const notificationCtaText = (
      <TextField
        key="ctaText"
        type="string"
        style={styles.width100}
        hintText="Notification CtaText"
        value={get(this.state, 'appOpenNotificationConfig.ctaText', '')}
        onChange={(e, newValue) =>
          this.onNudgeNotificationConfigUpdate(
            'ociConfigs',
            'ctaText',
            newValue,
          )
        }
      />
    );

	let channelType, cappingPacingCheck, advertiserId, creativeId;
    if (isSponsoredGlance) {
      channelType = (
        <DropDownMenu
          key="channelType"
          value={
            draft.programmaticDetail
              ? draft.programmaticDetail.channelType
              : ChannelType.DIRECT
          }
          onChange={(e, newValue) => {
            this.props.onEdit('channelType', newValue);
          }}
          disabled={!editable}
          style={{
            ...styles.width50,
            ...styles.marginTopLeft,
            ...styles.marginTopOnly,
          }}
        >
          <MenuItem
            primaryText={'Direct'}
            key="Direct"
            value={ChannelType.DIRECT}
          />
          <MenuItem
            primaryText={'Programmatic'}
            key="Programmatic"
            value={ChannelType.PROGRAMMATIC}
          />
        </DropDownMenu>
      );
      if (
        draft.programmaticDetail &&
        draft.programmaticDetail.channelType === ChannelType.PROGRAMMATIC
      ) {
        cappingPacingCheck = (
          <Toggle
            key="cappingPacingCheck"
            label="capping Pacing Check"
            type="boolean"
            style={styles.width45}
            toggled={
              (draft.programmaticDetail &&
                draft.programmaticDetail.cappingPacingCheck) ||
              false
            }
            onToggle={(e, newValue) => {
              this.props.onEdit('cappingPacingCheck', newValue);
            }}
          />
        );
        advertiserId = (
          <TextField
            key="advertiserId"
            type="string"
            style={styles.width100}
            hintText="advertiser Id"
            value={
              (draft.programmaticDetail &&
                draft.programmaticDetail.advertiserId) ||
              ''
            }
            onChange={(e, newValue) => {
              this.props.onEdit('advertiserId', newValue);
            }}
          />
        );
        creativeId = (
          <TextField
            key="creativeId"
            type="string"
            style={styles.width100}
            hintText="creativeId"
            value={
              (draft.programmaticDetail &&
                draft.programmaticDetail.creativeId) ||
              ''
            }
            onChange={(e, newValue) => {
              this.props.onEdit('creativeId', newValue);
            }}
          />
        );
      }
    }

    let selectedObjective = null;
    let selectedEcpm = null;
    let selectedGlroId = '';
    if (glanceDraftData.campaignMeta) {
      if (glanceDraftData.campaignMeta.objective) {
        selectedObjective = glanceDraftData.campaignMeta.objective;
      }
      if (glanceDraftData.campaignMeta.eCpm) {
        selectedEcpm = glanceDraftData.campaignMeta.eCpm;
      }
      if (glanceDraftData.campaignMeta.glroId) {
        selectedGlroId = glanceDraftData.campaignMeta.glroId;
      }
    }
    const campaignObjective =
      draft.peek && GlanceType.SPONSORED === draft.type && !isDspCampaign ? (
        <div>
          <DropDownMenu
            value={selectedObjective}
            onChange={this.handleCampaignObjectiveChange}
            disabled={!editable}
            style={{ ...styles.width40, ...styles.marginTopLeft }}
          >
            <MenuItem
              value={null}
              primaryText="Campaign Objective"
              style={styles.dropdownHeader}
            />

            {this.state.campaignObjectiveList
              ? this.state.campaignObjectiveList.map((objective) => {
                  return (
                    <MenuItem
                      key={objective}
                      value={objective}
                      primaryText={objective}
                    />
                  );
                })
              : null}
          </DropDownMenu>
          <div style={{ ...styles.spacedRow }}>
            <TextField
              type="number"
              key="adCoefficient"
              style={{ ...styles.width33, marginLeft: '5px' }}
              hintText="Ad. Coefficient"
              value={draft.adCoefficient}
              disabled={!editable || this.props.adCoefficientDisabled}
              onChange={(e, newValue) =>
                this.props.onEdit('adCoefficient', newValue)
              }
              errorText={
                draft.adCoefficient % 1 == 0 ? null : 'Please enter an integer'
              }
            />

            <DropDownMenu
              style={{ ...styles.width33 }}
              value={draft.bucketPriority}
              disabled={!editable || this.props.bucketPriorityDisabled}
              onChange={this.handleBucketPriorityChange}
            >
              <MenuItem
                key="house"
                value={BucketPriority.HOUSE}
                primaryText="House"
              />
              <MenuItem
                key="price"
                value={BucketPriority.PRICE_PRIORITY}
                primaryText="Price Priority"
              />
              <MenuItem
                key="low"
                value={BucketPriority.LOW_PRIORITY}
                primaryText="Low Priority"
              />
              <MenuItem
                key="high"
                value={BucketPriority.HIGH_PRIORITY}
                primaryText="High Priority"
              />
              <MenuItem
                key="sponsorship"
                value={BucketPriority.SPONSORSHIP}
                primaryText="Sponsorship"
              />
              <MenuItem
                key="none"
                value={null}
                primaryText="Bucket Priority"
                disabled
              />
            </DropDownMenu>
            <TextField
              type="number"
              key="campaignEcpm"
              style={{ ...styles.width33, marginLeft: '5px' }}
              value={eCpm}
              disabled={this.props.ecpmDisabled}
              hintText="Campaign eCPM"
              onChange={(e, newValue) =>
                this.onChange('campaignEcpm', e, newValue)
              }
              errorText={
                eCpm < 0.01 ? 'must be greater than or equal to 0.01' : null
              }
            />
          </div>
          {/* <Tooltip
            content="eCPM: min value is 0.01 ($)"
            styles={{ ...styles.width33, ...styles.tooltipStyle }}
          >
            <TextField
              key="campaignEcpm"
              style={{ ...styles.width100, ...styles.flagButton }}
              defaultValue={selectedEcpm}
              hintText="Campaign eCPM"
              onChange={(e, newValue) =>
                this.onChange('campaignEcpm', e, newValue)
              }
              onKeyDown={(e) => this.handleEcpmKeyDown(e)}
            />
          </Tooltip> */}
          {/* <TextField
            key="glroId"
            style={{ ...styles.width25, ...styles.flagButton }}
            defaultValue={selectedGlroId}
            hintText="GLRO ID"
            onChange={(e, newValue) => this.onChange('glroId', e, newValue)}
          /> */}
        </div>
      ) : null;

      const campaignObjectiveDSP =
        draft.peek &&
        GlanceType.SPONSORED === draft.type &&
        isDspCampaign ? (
          <div>
            <DropDownMenu
              value={selectedObjective}
              onChange={this.handleCampaignObjectiveChange}
              disabled={!editable}
              style={{ ...styles.width40, ...styles.marginTopLeft }}
            >
              <MenuItem
                value={null}
                primaryText="Campaign Objective"
                style={styles.dropdownHeader}
              />

              {AdPersonalisationList.map((objective) => {
                return (
                  <MenuItem
                    key={objective}
                    value={objective}
                    primaryText={objective}
                  />
                );
              })}
            </DropDownMenu>
            <DropDownMenu
              style={{ ...styles.width33 }}
              value={draft.bucketPriority}
              disabled={!editable || this.props.bucketPriorityDisabled}
              onChange={this.handleBucketPriorityChange}
            >
              <MenuItem
                key="house"
                value={BucketPriority.HOUSE}
                primaryText="House"
              />
              <MenuItem
                key="price"
                value={BucketPriority.PRICE_PRIORITY}
                primaryText="Price Priority"
              />
              <MenuItem
                key="low"
                value={BucketPriority.LOW_PRIORITY}
                primaryText="Low Priority"
              />
              <MenuItem
                key="high"
                value={BucketPriority.HIGH_PRIORITY}
                primaryText="High Priority"
              />
              <MenuItem
                key="sponsorship"
                value={BucketPriority.SPONSORSHIP}
                primaryText="Sponsorship"
              />
              <MenuItem
                key="none"
                value={null}
                primaryText="Bucket Priority"
                disabled
              />
            </DropDownMenu>
          </div>
        ) : null;

    const OmSdkInfoFields =
      glanceDraftData.peek && glanceDraftData.peek.nativeVideoUrl ? (
        <div style={{ ...styles.width100, ...styles.spacedRow }}>
          <DropDownMenu
            style={{ ...styles.width33, marginLeft: '-23px' }}
            value={
              glanceDraftData.omSdkInfo &&
              glanceDraftData.omSdkInfo.type != null
                ? glanceDraftData.omSdkInfo.type
                : null
            }
            disabled={!editable}
            onChange={this.handleOmSdkInfoType}
          >
            <MenuItem value={null} primaryText="OMSDK Type" />
            <MenuItem
              key="Advertiser"
              value={OmSdkInfoType.ADVERTISER}
              primaryText="Advertiser"
            />
            <MenuItem
              key="Sponsored"
              value={OmSdkInfoType.SPONSORED}
              primaryText="Sponsored"
            />
          </DropDownMenu>
          <TextField
            key="validationUrl"
            style={{ ...styles.width20, ...styles.flagButton }}
            defaultValue={
              glanceDraftData.omSdkInfo &&
              glanceDraftData.omSdkInfo.validationUrl
                ? glanceDraftData.omSdkInfo.validationUrl
                : ''
            }
            hintText="Validation Url"
            onChange={(e, newValue) =>
              this.onChange('validationUrl', e, newValue)
            }
          />
          <TextField
            key="verificationParam"
            style={{ ...styles.width25, ...styles.flagButton }}
            defaultValue={
              glanceDraftData.omSdkInfo &&
              glanceDraftData.omSdkInfo.verificationParam
                ? glanceDraftData.omSdkInfo.verificationParam
                : ''
            }
            hintText="Verification Param"
            onChange={(e, newValue) =>
              this.onChange('verificationParam', e, newValue)
            }
          />
          <TextField
            key="vendorKey"
            style={{ ...styles.width20, ...styles.flagButton }}
            defaultValue={
              glanceDraftData.omSdkInfo && glanceDraftData.omSdkInfo.vendorKey
                ? glanceDraftData.omSdkInfo.vendorKey
                : ''
            }
            hintText="Vendor Key"
            onChange={(e, newValue) => this.onChange('vendorKey', e, newValue)}
          />
        </div>
      ) : null;

    const glanceContext = (
      <DropDownMenu
        style={{ ...styles.width33, marginLeft: '-23px' }}
        value={
          glanceDraftData.peek && glanceDraftData.peek.glanceContext != null
            ? glanceDraftData.peek.glanceContext
            : null
        }
        disabled={!editable}
        onChange={this.handleGlanceContextChange}
      >
        <MenuItem value={null} primaryText="GlanceContext" />
        <MenuItem
          key="Live"
          value={GlanceContextType.LIVE}
          primaryText="Live"
        />
        <MenuItem
          key="Featured"
          value={GlanceContextType.FEATURED}
          primaryText="Featured"
        />
        <MenuItem
          key="Launch"
          value={GlanceContextType.LAUNCH}
          primaryText="Launch"
        />
        <MenuItem
          key="Nearby"
          value={GlanceContextType.NEARBY}
          primaryText="Nearby"
        />
        <MenuItem
          key="Exclusive"
          value={GlanceContextType.EXCLUSIVE}
          primaryText="Exclusive"
        />
        <MenuItem key="Fun" value={GlanceContextType.FUN} primaryText="Fun" />
        <MenuItem
          key="Hatke"
          value={GlanceContextType.HATKE}
          primaryText="Hatke"
        />
        <MenuItem key="Hot" value={GlanceContextType.HOT} primaryText="Hot" />
        <MenuItem
          key="Popular"
          value={GlanceContextType.POPULAR}
          primaryText="Popular"
        />
        <MenuItem
          key="Viral"
          value={GlanceContextType.VIRAL}
          primaryText="Viral"
        />
        <MenuItem
          key="Trending"
          value={GlanceContextType.TRENDING}
          primaryText="Trending"
        />
        <MenuItem
          key="Breaking News"
          value={GlanceContextType.BREAKING_NEWS}
          primaryText="Breaking News"
        />
        <MenuItem
          key="Category"
          value={GlanceContextType.CATEGORY}
          primaryText="Category"
        />
        <MenuItem
          key="Shopping"
          value={GlanceContextType.SHOPPING}
          primaryText="Shopping"
        />
      </DropDownMenu>
    );

    function glance_context(context): string {
      switch (context) {
        case 0:
          return 'Live';
        case 1:
          return 'Featured';
        case 2:
          return 'Launch';
        case 3:
          return 'Nearby';
        case 4:
          return 'Viral';
        case 5:
          return 'Hot';
        case 6:
          return 'Trending';
        case 7:
          return 'Hatke';
        case 8:
          return 'Exclusive';
        case 9:
          return 'Fun';
        case 10:
          return 'Popular';
        case 11:
          return 'Breaking News';
        case 12:
          return 'Category';
        case 13:
          return 'Shopping';
        default:
          return 'GlanceContext';
      }
    }
    let ctaType = null;
    if (
      glanceDraftData.type &&
      (glanceDraftData.type === GlanceType.SPONSORED ||
        glanceDraftData.type === GlanceType.STORY)
    ) {
      ctaType = (
        <DropDownMenu
          style={{ ...styles.width33, marginLeft: '-24px' }}
          value={
            glanceDraftData.peek && glanceDraftData.peek.ctaType != null
              ? glanceDraftData.peek.ctaType
              : PropositionType.CTA_URL
          }
          onChange={this.handleCtaTypeChange}
          disabled={!editable}
        >
          <MenuItem
            key="OPEN_URL"
            value={PropositionType.CTA_URL}
            primaryText="OPEN_URL"
          />
          <MenuItem
            key="INSTALL_APP"
            value={PropositionType.APP_INSTALL}
            primaryText="INSTALL_APP"
          />
        </DropDownMenu>
      );
    }

    const error = (
      <div style={{ ...styles.emojiErrorCont }}>
        <div style={{ ...styles.errorCont }}>
          <Ban />
        </div>
        <div style={{ ...styles.errorCont }}>
          <div style={{ ...styles.errorBold }}>Error</div>
          <div style={{ ...styles.errorMessage }}>Same emojis selected</div>
        </div>
      </div>
    );

    const emoji = this.props.glanceDraftData.peek.tvVideoPeek && (
      <div
        style={{
          display: 'flex',
          height: '48px',
          alignItems: 'flex-end',
        }}
      >
        {this.state.currEmojis.map((emoji: Emoji, idx) => (
          <div
            style={{
              ...styles.contextualEmoji,
              ...(this.state.sameEmoji === emoji.id && {
                ...styles.errorBorder,
              }),
            }}
            key={`${emoji.id}${idx}`}
            onClick={(e) => this.handleEmojiClick(emoji, e, idx)}
            onMouseEnter={() =>
              this.setState({
                ...this.state,
                hoveredEmoji: idx,
              })
            }
            onMouseLeave={() =>
              this.setState({
                ...this.state,
                hoveredEmoji: null,
              })
            }
          >
            {emoji.mediaType === EMOJI_FORMAT.LOTTIE ? (
              <LottieAnimation url={emoji.cdnUrl} />
            ) : (
              <img
                src={emoji.cdnUrl}
                width={'32px'}
                height={'32px'}
                alt={''}
                style={{
                  // borderRadius: '50%',
                  objectFit: 'contain',
                }}
              />
            )}
            <div
              style={{
                ...styles.emojiHoverWrapper,
                ...(this.state.hoveredEmoji !== null &&
                  this.state.hoveredEmoji === idx && {
                    visibility: 'visible',
                  }),
              }}
            >
              <div
                style={{
                  ...styles.emojiEditWrapper,
                  justifyContent: 'center',
                }}
              >
                {/* <img
                //   src='../../../../assets/images/mdi_pencil.png'
                  alt={'edit img'}
                  width={'18px'}
                  height={'18px'}
                /> */}
                <Pencil />
              </div>
            </div>
          </div>
        ))}

        <Popover
          open={this.state.showPopover}
          anchorEl={this.state.selectedEmoji.target}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          targetOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          onRequestClose={() =>
            this.setState({
              ...this.state,
              showPopover: false,
              emojiUploadError: [],
            })
          }
          style={{ ...styles.popoverStyle }}
        >
          <div style={{ ...styles.popoverUpper }}>
            <span style={{ ...styles.emojiHeading }}>Select an emoji</span>
            <div style={{ ...styles.fileuploadImg }}>
              <label htmlFor="file-input" style={{ marginBottom: 0 }}>
                <FileUpload />
              </label>
              <input
                id="file-input"
                type="file"
                accept=".png,.svg,.json,.gif"
                style={{ display: 'none' }}
                multiple
                onChange={(e) => {
                  this.handleFileUpload(e);
                }}
              />
            </div>
          </div>
          <div
            style={{
              ...styles.popoverEmojiContainer,
            }}
          >
            <div style={{ ...styles.popoverCenter }}>
              <Divider style={{ ...styles.popoverhr }} />
              {this.state.emojiUploadError.length > 0 && (
                <div style={{ ...styles.emojiUploadErrorMessageContainer }}>
                  {this.state.emojiUploadError.map((error) => (
                    <div
                      style={{
                        ...styles.emojiUploadErrorMessage,
                      }}
                    >
                      {error.message}
                    </div>
                  ))}
                </div>
              )}
              <div style={{ ...styles.emojiPopoverContainer }}>
                {this.state.allEmojis.length > 0 &&
                  this.state.allEmojis.map((emoji: Emoji) => (
                    <div style={{ ...styles.emojiStyling }}>
                      {emoji.mediaType === EMOJI_FORMAT.LOTTIE ? (
                        <div
                          style={{ ...styles.emojiInnerMargin }}
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              chosenEmoji: emoji,
                            })
                          }
                        >
                          <LottieAnimation url={emoji.cdnUrl} />
                        </div>
                      ) : (
                        <img
                          src={emoji.cdnUrl}
                          width={'32px'}
                          height={'32px'}
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              chosenEmoji: emoji,
                            })
                          }
                          alt=""
                          style={{
                            ...styles.popoverEmojimr,
                            objectFit: 'contain',
                          }}
                        />
                      )}
                      {this.state.chosenEmoji &&
                        this.state.chosenEmoji.id === emoji.id && (
                          <div style={{ ...styles.chosenEmoji }}>
                            <Selected />
                          </div>
                        )}
                    </div>
                  ))}
              </div>
            </div>
            <div>
              {this.state.fileUploadError && (
                <div style={{ textAlign: 'center' }}> File Upload error </div>
              )}
              <div
                style={{
                  ...styles.popoverButtonContainer,
                }}
              >
                <button
                  style={{
                    ...styles.popoverCancelBtn,
                  }}
                  onClick={() =>
                    this.setState({
                      ...this.state,
                      showPopover: false,
                      emojiUploadError: [],
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  style={{
                    ...styles.popoverReplaceBtn,
                  }}
                  onClick={() =>
                    this.handleReplaceEmoji(this.state.chosenEmoji)
                  }
                >
                  Replace
                </button>
              </div>
            </div>
          </div>
        </Popover>
      </div>
    );

		const gamPgAdUnitId = isSponsoredGlance && (
      <TextField
        key="gamPgAdUnitId"
        style={styles.width100}
        hintText="GAM PG Adunit Id"
        defaultValue={draft.gamPgAdUnitId}
        onChange={(e, newValue) => this.onChange('gamPgAdUnitId', e, newValue)}
      />
    );

    const isShoppable = (
      <Chip
        style={styles.clickableChip}
        key={'isShoppable'}
        backgroundColor={draft.isShoppable ? blue300 : null}
        onTouchTap={() => {
          this.handleIsShoppable(!draft.isShoppable);
        }}
      >
        {draft.isShoppable ? 'Shoppable' : 'Not Shoppable'}
      </Chip>
    );

    let shoppableData = null;
    if (glanceDraftData.type && glanceDraftData.isShoppable) {
      shoppableData = (
        <div>
          <TextField
            key="iconToolTip"
            style={styles.width100}
            hintText="Icon Tool Tip"
            defaultValue={draft.shoppableData.iconToolTip}
            onChange={(e, newValue) =>
              this.onChange('iconToolTip', e, newValue)
            }
          />
          <TextField
            key="iconImageUrl"
            style={styles.width100}
            hintText="Icon Image Url"
            defaultValue={draft.shoppableData.iconImageUrl}
            onChange={(e, newValue) =>
              this.onChange('iconImageUrl', e, newValue)
            }
          />
          <TextField
            key="shoppingUrl"
            style={styles.width100}
            hintText="Shopping Url"
            defaultValue={draft.shoppableData.shoppingUrl}
            onChange={(e, newValue) =>
              this.onChange('shoppingUrl', e, newValue)
            }
          />
          <TextField
            key="offlineShoppingZipUrl"
            style={styles.width100}
            hintText="Offline Shopping Zip Url"
            defaultValue={draft.shoppableData.offlineShoppingZipUrl}
            onChange={(e, newValue) =>
              this.onChange('offlineShoppingZipUrl', e, newValue)
            }
          />
        </div>
      );
    }

    const userAgeFilterTpl = (
      <GridList cellHeight="auto">
        <GridTile>
          <SelectField
            value={
              userLifeTimeFilter && userLifeTimeFilter.startDay !== null
                ? userLifeTimeFilter.startDay
                : null
            }
            onChange={(field, context, value) =>
              this.handleGlanceUserAgeFilterChange(value, 'startDay')
            }
          >
            <MenuItem key="startDay--1" value={null} primaryText="All Users" />
            {startDays.map((stday) => (
              <MenuItem
                key={`startDay-${stday}`}
                value={stday}
                primaryText={stday <= 7 ? stday : `${stday - 1}+`}
              />
            ))}
          </SelectField>
        </GridTile>

        <GridTile>
          <SelectField
            value={
              userLifeTimeFilter && userLifeTimeFilter.endDay
                ? userLifeTimeFilter.endDay
                : null
            }
            disabled={
              !userLifeTimeFilter.startDay ||
              userLifeTimeFilter.startDay === 8 ||
              userLifeTimeFilter.startDay === -1
            }
            onChange={(feild, context, value) =>
              this.handleGlanceUserAgeFilterChange(value, 'endDay')
            }
          >
            <MenuItem key="engDay-null" value={null} primaryText="End Day" />
            {endDays.map((endDay) => (
              <MenuItem
                key={`endDay-${endDay}`}
                value={endDay}
                primaryText={endDay}
              />
            ))}
          </SelectField>
        </GridTile>
      </GridList>
    );

    const shareContent = (
      <div>
        <Chip
          style={{
            ...styles.clickableChip,
            ...(isSponsoredGlance
              ? { opacity: 0.4, pointerEvents: 'none' }
              : {}),
          }}
          key={'is_shareable'}
          backgroundColor={draft.isShareable ? blue300 : null}
          onTouchTap={() => {
            !isSponsoredGlance && this.handleIsShareable(!draft.isShareable);
          }}
        >
          {draft.isShareable ? 'Shareable' : 'Not Shareable'}
        </Chip>
        <TextField
          key="ShareUrl"
          style={styles.width83}
          hintText="Share Url"
          defaultValue={draft.shareUrl}
          disabled={!draft.isShareable}
          onChange={(e, newValue) => this.onChange('shareUrl', e, newValue)}
        />
      </div>
    );

    const homescreenWorthyElem = (
      <Chip
        style={{ ...styles.clickableChip }}
        key={'homescreenWorthy'}
        backgroundColor={draft.homescreenWorthy ? blue300 : null}
        onTouchTap={() => {
          this.handleHomeScreenWorthy(!draft.homescreenWorthy);
        }}
      >
        {draft.homescreenWorthy ? 'Homescreenworthy' : 'Not Homescreenworthy'}
      </Chip>
    );

    const allowKeyboardElem = (
      <Tooltip
        content="Keep this off for using the virtual keyboard"
        styles={{ ...styles.width33, ...styles.tooltipStyle }}
      >
        <Chip
          style={{ ...styles.clickableChip }}
          key={'allowKeyboard'}
          backgroundColor={draft.allowKeyboard ? blue300 : null}
          onTouchTap={() => {
            this.handleAllowKeyboard(!draft.allowKeyboard);
          }}
        >
          {'Allow Keyboard < 8.19'}
        </Chip>
      </Tooltip>
    );

    const allowNativeKeyboardElem = (
      <Tooltip
        content="Keep this off for using the virtual keyboard"
        styles={{ ...styles.width33, ...styles.tooltipStyle }}
      >
        <Chip
          style={{ ...styles.clickableChip }}
          key={'allowNativeKeyboard'}
          backgroundColor={draft.allowNativeKeyboard ? blue300 : null}
          onTouchTap={() => {
            this.handleAllowNativeKeyboard(!draft.allowNativeKeyboard);
          }}
        >
          {'Allow Keyboard >= 8.19'}
        </Chip>
      </Tooltip>
    );

    const dynamicOverlayElem = (
      <Chip
        style={{ ...styles.clickableChip }}
        key={'dynamicOverlay'}
        backgroundColor={draft.dynamicOverlay ? blue300 : null}
        onTouchTap={() => {
          this.handleDynamicOverlay(!draft.dynamicOverlay);
        }}
      >
        {draft.dynamicOverlay ? 'Dynamic Overlay' : 'No Dynamic Overlay'}
      </Chip>
    );

    const gPayReadinessElem = (
      <Chip
        style={{ ...styles.clickableChip }}
        key={'gPayReadiness'}
        backgroundColor={
          draft.targeting && draft.targeting.requiresGPayReadiness
            ? blue300
            : null
        }
        onTouchTap={() => {
          this.handleGPayReadiness(
            draft.targeting && draft.targeting.requiresGPayReadiness
              ? !draft.targeting.requiresGPayReadiness
              : true,
          );
        }}
      >
        {draft.targeting && draft.targeting.requiresGPayReadiness
          ? 'GPay Required'
          : 'GPay Not Required'}
      </Chip>
    );

    const childLockFlagElem = (
      <Chip
        style={{ ...styles.clickableChip }}
        key={'childlockflag'}
        backgroundColor={
          draft.targeting && draft.targeting.childLockFlag ? blue300 : null
        }
        onTouchTap={() => {
          this.handleChildLockFlag(
            draft.targeting && draft.targeting.childLockFlag
              ? !draft.targeting.childLockFlag
              : true,
          );
        }}
      >
        {draft.targeting && draft.targeting.childLockFlag
          ? 'Childlock flag Off'
          : 'Childlock flag On'}
      </Chip>
    );

	const useUnlockNudgeElem = isSponsoredGlance && (
      <Chip
        style={{ ...styles.clickableChip }}
        key={'useUnlockNudge'}
        backgroundColor={
          draft && draft.useUnlockNudge ? blue300 : null
        }
        onTouchTap={() => {
          this.handleUseUnlockNudge(
            draft && draft.useUnlockNudge
              ? !draft.useUnlockNudge
              : true,
          );
        }}
      >
        {draft && draft.useUnlockNudge
          ? 'Unlock Nudge'
          : 'No Unlock Nudge'}
      </Chip>
    );

    const dspRetargetingElem =
      glanceDraftData.type && glanceDraftData.type == GlanceType.SPONSORED ? (
        <Chip
          style={{ ...styles.clickableChip }}
          key={'dspRetargeting'}
          backgroundColor={
            draft.targeting && draft.targeting.enableDSPRetargeting
              ? blue300
              : null
          }
          onTouchTap={() => {
            this.handleDspRetargeting(
              draft.targeting && draft.targeting.enableDSPRetargeting
                ? !draft.targeting.enableDSPRetargeting
                : true,
            );
          }}
        >
          {draft.targeting && draft.targeting.enableDSPRetargeting
            ? 'DSP Retargeting'
            : 'No DSP Retargeting'}
        </Chip>
      ) : null;

    const getFileFormat = (url) =>
      url
        .split(/\#|\?/)[0]
        .split('.')
        .pop()
        .trim();
    const showNativeOverflow =
      draft.peek &&
      draft.peek.videoUrl &&
      (getFileFormat(draft.peek.videoUrl) === 'mp4' ||
        getFileFormat(draft.peek.videoUrl) === 'webm');
    const videoOverflowElem = showNativeOverflow ? (
      <div>
        <Chip
          style={styles.clickableChip}
          key={'shouldOverflow'}
          backgroundColor={draft.peek.nativeVideoOverflow ? blue300 : null}
          onTouchTap={() => {
            this.handleNativeOverflow(!draft.peek.nativeVideoOverflow);
          }}
        >
          {draft.peek.nativeVideoOverflow ? 'Native Overflow' : 'No Overflow'}
        </Chip>
      </div>
    ) : null;

    const hardwareAccelerated =
      draft.peek && draft.peek.webPeekUrl ? (
        <Chip
          style={styles.clickableChip}
          key={'hardware_accelerated'}
          backgroundColor={draft.peek.hardwareAccelerated ? blue300 : null}
          onTouchTap={() => {
            this.handleHardwareAccelerated(!draft.peek.hardwareAccelerated);
          }}
        >
          {draft.peek.hardwareAccelerated
            ? 'Advanced peek webview'
            : 'Not advanced peek webview'}
        </Chip>
      ) : null;

    const loadAndroidJs =
      draft.peek && !draft.peek.webPeekUrl ? (
        <Chip
          style={styles.clickableChip}
          key={'load_android_js'}
          backgroundColor={draft.peek.loadAndroidJs ? blue300 : null}
          onTouchTap={() => {
            this.handleLoadAndroidJs(!draft.peek.loadAndroidJs);
          }}
        >
          {draft.peek.loadAndroidJs
            ? 'Advanced CTA webview'
            : 'Not advanced CTA webview'}
        </Chip>
      ) : null;

    const s2sIntegration = !draft.beaconsInfo
      ? false
      : draft.beaconsInfo.s2sIntegration;

    const beaconEntry =
      glanceDraftData.type &&
      (glanceDraftData.type === GlanceType.SPONSORED ||
        glanceDraftData.type === GlanceType.STORY) ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <TextField
            key="BeaconUrl"
            errorText={this.state.beaconError || null}
            style={{ ...styles.width100, float: 'left' }}
            hintText="BeaconUrl"
            onChange={(e, newValue) => this.handleBeaconUrlChange(newValue)}
            defaultValue={this.state.beaconUrl}
            multiLine={true}
            rows={1}
            rowsMax={4}
          />
          <DropDownMenu
            value={this.state.beaconType}
            style={{
              ...styles.width33,
              maxWidth: 'none',
              paddingBottom: '6px',
              float: 'left',
              marginLeft: '-24px',
            }}
            disabled={!editable}
            onChange={this.handleBeaconTypeChange}
          >
            <MenuItem value={BeaconType.RENDER} primaryText="Render Beacon" />
            {this.state.linkType == 'videoUrl' ? (
              <MenuItem value={BeaconType.VIDEO} primaryText="Video Beacon" />
            ) : null}
            {this.state.linkType == 'videoUrl' ||
            (glanceDraftData.peek && glanceDraftData.peek.videoCtaUrl) ||
            this.state.linkType == 'ctaUrl' ||
            this.state.linkType == 'webPeekUrl' ? (
              <MenuItem value={BeaconType.CTA} primaryText="Cta Beacon" />
            ) : null}
            {draft.peek ? (
              <MenuItem value={BeaconType.PEEK} primaryText="Peek Beacon" />
            ) : null}
            <MenuItem value={BeaconType.LIKE} primaryText="Like Beacon" />
            <MenuItem value={BeaconType.SHARE} primaryText="Share Beacon" />
            {glanceDraftData.type === GlanceType.SPONSORED && (
              <MenuItem
                value={BeaconType.VIDEO_STARTED}
                primaryText="Video Started Beacon"
              />
            )}
            <MenuItem value={BeaconType.HOLD} primaryText="Hold Beacon" />
            <MenuItem
              value={BeaconType.APP_SUBMIT}
              primaryText="App Submit Beacon"
            />
            <MenuItem
              value={BeaconType.INSTALL_NOW}
              primaryText="Install Now Beacon"
            />
            <MenuItem
              value={BeaconType.INSTALL_LATER}
              primaryText="Install Later Beacon"
            />
            <MenuItem
              value={BeaconType.INSTALL_COMPLETE}
              primaryText="Install Complete Beacon"
            />
            <MenuItem
              value={BeaconType.APP_OPEN}
              primaryText="App Open Beacon"
            />
            <MenuItem
              value={BeaconType.GLANCE_STARTED}
              primaryText="Glance Started Beacon"
            />
            <MenuItem
              value={BeaconType.PRIVIEW_TAP}
              primaryText="Priview Tap Beacon"
            />
            <MenuItem
              value={BeaconType.VIDEO_VIEWED}
              primaryText="Video Viewed Beacon"
            />
            <MenuItem
              value={BeaconType.GLANCE_VIEWED}
              primaryText="Glance Viewed Beacon"
            />
          </DropDownMenu>

          <DropDownMenu
            value={this.state.beaconPartner}
            style={{
              ...styles.width33,
              width: '35%',
              maxWidth: 'none',
              paddingBottom: '6px',
              float: 'left',
              marginLeft: '-24px',
            }}
            disabled={!editable}
            onChange={this.handleBeaconPartnerChange}
          >
            <MenuItem value={''} primaryText="Tracking Partner" />
            {Constants.BEACON_PARTNERS.map((each) => (
              <MenuItem value={each} primaryText={each} />
            ))}
          </DropDownMenu>

          {this.state.beaconType === BeaconType.GLANCE_STARTED && (
            <TextField
              key="DelayDurationInMillis"
              style={{ maxWidth: 'none', ...styles.width17, float: 'left' }}
              hintText="Delay(ms)"
              type="number"
              onChange={(e, newValue) =>
                this.handleDelayDurationInMillis(Number(newValue))
              }
              defaultValue={this.state.delayDurationInMillis}
            />
          )}

          <TextField
            key="MinDurationInSecs"
            disabled={
              !(
                this.state.beaconType == BeaconType.RENDER ||
                this.state.beaconType == BeaconType.VIDEO_VIEWED ||
                this.state.beaconType == BeaconType.GLANCE_VIEWED
              )
            }
            style={{ maxWidth: 'none', ...styles.width17, float: 'left' }}
            hintText="duration"
            type="number"
            onChange={(e, newValue) =>
              this.handleMinDurationInSecsChange(Number(newValue))
            }
            defaultValue={this.state.minDurationInSecs}
          />
          <Chip
            style={{
              ...styles.clickableChip,
              ...styles.width17,
              height: 'fit-content',
              textAlign: 'center',
              margin: '12px 0 6px 4px',
            }}
            onTouchTap={this.addBeacon}
          >
            ADD
          </Chip>
          {this.state.beacons ? (
            <Chip
              style={{
                ...styles.clickableChip,
                height: 'fit-content',
                margin: '12px 0 6px 4px',
              }}
              key={'s2sIntegration'}
              backgroundColor={s2sIntegration ? blue300 : null}
              onTouchTap={() => {
                this.handleS2sIntegration(!s2sIntegration);
              }}
            >
              {s2sIntegration
                ? 'S2S Integration Enabled'
                : 'S2S Integration Disabled'}
            </Chip>
          ) : null}
        </div>
      ) : null;

    const totalImpressionRequired = (
      <TextField
        key="totalImpressionRequired"
        style={{ ...styles.width50 }}
        defaultValue={
          draft.impressionCappingData &&
          draft.impressionCappingData.totalImpressionRequired
            ? draft.impressionCappingData.totalImpressionRequired
            : null
        }
        hintText="Total Impression Required"
        type="number"
        onChange={(e, newValue) => this.handleImpressionRequired(e, newValue)}
        disabled={
          !draft.impressionCappingData &&
          this.state.publishValue === DraftState.PUBLISHED
        }
      />
    );

    const glanceTimer = (
      <div>
        <TextField
          key="glanceTimer"
          style={{ ...styles.width50 }}
          defaultValue={
            draft.glanceBubbleDetails && draft.glanceBubbleDetails.glanceTimer
              ? draft.glanceBubbleDetails.glanceTimer / 1000
              : null
          }
          hintText="Glance Timer (in sec)"
          disabled={!editable}
          onChange={(e, newValue) => this.onChange('glanceTimer', e, newValue)}
          type="number"
        />
      </div>
    );

    const triggerPercentage =
      this.state.showTriggerPercentage ||
      (draft.impressionCappingData &&
        draft.impressionCappingData.totalImpressionRequired) ? (
        <div style={styles.servingCappingWrapper}>
          <TextField
            key="triggerPercentage"
            style={{ ...styles.width45, ...styles.flagButton }}
            defaultValue={
              draft.impressionCappingData &&
              draft.impressionCappingData.triggerPercentage
                ? draft.impressionCappingData.triggerPercentage
                : null
            }
            type="percentage"
            hintText="Trigger Percentage"
            onChange={(e, newValue) =>
              this.onChange('triggerPercentage', e, newValue)
            }
          />
          <Chip
            style={{ ...styles.chipStyle, ...styles.width45 }}
            key={'servingCappingEnabled'}
            backgroundColor={
              draft.impressionCappingData.servingCappingEnabled ? blue300 : null
            }
            onTouchTap={() => {
              this.handleServingCappingEnabled(
                !draft.impressionCappingData.servingCappingEnabled,
              );
            }}
          >
            {draft.impressionCappingData.servingCappingEnabled
              ? 'Serving Capping Enable'
              : 'Serving Capping Disable'}
          </Chip>
        </div>
      ) : null;

    const beaconTable =
      this.state.beacons &&
      glanceDraftData.type &&
      (glanceDraftData.type == GlanceType.SPONSORED ||
        glanceDraftData.type == GlanceType.STORY) ? (
        <Table
          key="beaconTable"
          multiSelectable={false}
          selectable={false}
          style={{
            ...styles.width100,
            height: '100%',
            display: 'inline-block',
          }}
        >
          <TableHeader
            key="beaconTableHeader"
            style={{ ...styles.width100 }}
            adjustForCheckbox={false}
            displaySelectAll={false}
          >
            <TableHeaderColumn
              style={{
                maxWidth: '150px',
                wordWrap: 'break-word',
                padding: '0px 10px 0 0',
              }}
            >
              Beacon type
              <br />
              and partner
            </TableHeaderColumn>
            <TableHeaderColumn
              style={{
                width: '300px',
                maxWidth: '300px',
                wordWrap: 'break-word',
                padding: '0 10px',
                textAlign: 'center',
              }}
            >
              Beacon Url
            </TableHeaderColumn>
            <TableHeaderColumn
              style={{
                width: '26px',
                wordWrap: 'break-word',
                padding: '0 10px',
              }}
            ></TableHeaderColumn>
            <TableHeaderColumn
              style={{
                width: '100px',
                maxWidth: '100px',
                wordWrap: 'break-word',
                paddingLeft: 0,
              }}
            >
              Duration(Minimum/Delay)
            </TableHeaderColumn>
            <TableHeaderColumn
              style={{
                width: '80px',
                maxWidth: '80px',
                wordWrap: 'break-word',
                padding: '0 10px',
              }}
            ></TableHeaderColumn>
          </TableHeader>
          <TableBody
            key="beaconTableBody"
            displayRowCheckbox={false}
            style={{ ...styles.width100 }}
          >
            {this.state.beacons && this.state.beacons.renderBeacons
              ? this.state.beacons.renderBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.RENDER}
                      beaconList={glanceDraftData.beacons.renderBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.videoBeacons
              ? this.state.beacons.videoBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.VIDEO}
                      beaconList={glanceDraftData.beacons.videoBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.peekBeacons
              ? this.state.beacons.peekBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.PEEK}
                      beaconList={glanceDraftData.beacons.peekBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.ctaBeacons
              ? this.state.beacons.ctaBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.CTA}
                      beaconList={glanceDraftData.beacons.ctaBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.likeBeacons
              ? this.state.beacons.likeBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.LIKE}
                      beaconList={glanceDraftData.beacons.likeBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.shareBeacons
              ? this.state.beacons.shareBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.SHARE}
                      beaconList={glanceDraftData.beacons.shareBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.videoStartedBeacons
              ? this.state.beacons.videoStartedBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.VIDEO_STARTED}
                      beaconList={glanceDraftData.beacons.videoStartedBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.holdBeacons
              ? this.state.beacons.holdBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.HOLD}
                      beaconList={glanceDraftData.beacons.holdBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.appSubmitBeacons
              ? this.state.beacons.appSubmitBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.APP_SUBMIT}
                      beaconList={glanceDraftData.beacons.appSubmitBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.installNowBeacons
              ? this.state.beacons.installNowBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.INSTALL_NOW}
                      beaconList={glanceDraftData.beacons.installNowBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.installLaterBeacons
              ? this.state.beacons.installLaterBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.INSTALL_LATER}
                      beaconList={glanceDraftData.beacons.installLaterBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.installCompleteBeacons
              ? this.state.beacons.installCompleteBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.INSTALL_COMPLETE}
                      beaconList={
                        glanceDraftData.beacons.installCompleteBeacons
                      }
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.appOpenBeacons
              ? this.state.beacons.appOpenBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.APP_OPEN}
                      beaconList={glanceDraftData.beacons.appOpenBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.glanceStartedBeacons
              ? this.state.beacons.glanceStartedBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.GLANCE_STARTED}
                      beaconList={glanceDraftData.beacons.glanceStartedBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.previewTapBeacons
              ? this.state.beacons.previewTapBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.PRIVIEW_TAP}
                      beaconList={glanceDraftData.beacons.previewTapBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.videoViewedBeacons
              ? this.state.beacons.videoViewedBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.VIDEO_VIEWED}
                      beaconList={glanceDraftData.beacons.videoViewedBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
            {this.state.beacons && this.state.beacons.glanceViewedBeacons
              ? this.state.beacons.glanceViewedBeacons.map((n, i) => {
                  return (
                    <BeaconTableRow
                      beaconType={BeaconType.GLANCE_VIEWED}
                      beaconList={glanceDraftData.beacons.glanceViewedBeacons}
                      index={i}
                      beaconItem={n}
                      removeBeacon={this.removeBeacon}
                      s2sFlag={s2sIntegration}
                    />
                  );
                })
              : null}
          </TableBody>
        </Table>
      ) : null;

    const emojiSection = (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {glanceContext} {emoji} {this.state.sameEmoji && error}
      </div>
    );

    const publishSection = (
      <div style={{ display: 'flex', padding: '5px 0px' }}>
        {publisherOptions}
        {stickiness}
      </div>
    );

    if (isDspCampaign) {
      leftElements.push(
        title,
        shortTitle,
        summary,
        cheesySummary,
        priority,
        shouldUnlock,
        openInBg,
        glanceType,
        dspCampaign,
        glanceTimer,
      );
    } else {
      leftElements.push(
        warningTextGLAM,
        title,
        shortTitle,
        summary,
        cheesySummary,
        priority,
        shouldUnlock,
        openInBg,
        glanceType,
        dspCampaign,
        storyType,
        totalImpressionRequired,
        triggerPercentage,
        glanceTimer,
      );
    }
    
    if (isDspCampaign) {
      middleElements.push(
        peekLink,
        zipTypes,
        curationReason,
        lsSubtext,
        lockscreenCtaText,
        ctaText,
        afterOciAppSelect,
        sourceName,
        attributionSource,
        negativeAppList,
        negativeTargeting,
        positiveAppList,
        positiveTargeting,
        networkTargeting,
        bubbles,
        rank,
        campaignObjectiveDSP,
        canSkipSummary,
        sessionMode,
        publisherOptions,
        <OCIAppList />,
        NudgeWebUrl,
        NudgeCtaText,
        NudgeDescription,
        ShowNudge,
        isBeautifulWallpaper, // Not listed
        NudgeMode,
        notificationEnabled,
        notificationIconUrl,
        notificationTitle,
        notificationDescription,
        notificationCtaText,
        shoppableData, // Not listed
        useUnlockNudgeElem,
      );
    } else {
      middleElements.push(
        peekLink,
        offlinePeekLink,
        videoCtaUrl,
        zipTypes,
        articleCtaUrl,
        curationReason,
        lsSubtext,
        lockscreenCtaText,
        ctaText,
        afterOciAppSelect,
        CtaViewConfigHeight,
        ctaViewHideTopPadding,
        ctaViewHideCrossIcon,
        sourceName,
        hearts,
        attributionSource,
        contentTags,
        categories,
        euValuePropList,
        sourceCreatorId,
        cities,
        carriers,
        negativeAppList,
        negativeTargeting,
        positiveAppList,
        positiveTargeting,
        networkTargeting,
        segments,
        bubbles,
        rank,
        topicName,
        campaignObjective,
        languageLimit,
        canSkipSummary,
        dailyCap,
        weeklyCap,
        sessionMode,
        emojiSection,
        publishSection,
        antiSegments,
        beaconTable,
        beaconEntry,
        OmSdkInfoFields,
        ctaType,
        userAgeFilterTpl,
        targetForCategory,
        sdkSubscribedCategoriesFilter,
        shareContent,
        <OCIAppList />,
        AutoOpenWrapper,
        NudgeWebUrl,
        NudgeCtaText,
        NudgeDescription,
        ShowNudge,
        isHardWareAcceleration,
        isBeautifulWallpaper,
        NudgeMode,
        notificationEnabled,
        notificationIconUrl,
        notificationTitle,
        notificationDescription,
        notificationCtaText,
        channelType,
        cappingPacingCheck,
        advertiserId,
        creativeId,
        gamPgAdUnitId,
        homescreenWorthyElem,
        allowKeyboardElem,
        allowNativeKeyboardElem,
        dynamicOverlayElem,
        gPayReadinessElem,
        dspRetargetingElem,
        videoOverflowElem,
        hardwareAccelerated,
        loadAndroidJs,
        isShoppable,
        childLockFlagElem,
        shoppableData,
        useUnlockNudgeElem,
      );
    }

    const nonDSPCountryFlags = [
      { name: 'USA', code: Region.US },
      { name: 'India', code: Region.IN },
      { name: 'Indonesia', code: Region.ID },
      { name: 'Australia', code: Region.AU },
      { name: 'New Zealand', code: Region.NZ },
      { name: 'Philippines', code: Region.PH },
      { name: 'Singapore', code: Region.SG },
      { name: 'Cambodia', code: Region.KH },
      { name: 'Myanmar', code: Region.MM },
      { name: 'Thailand', code: Region.TH },
      { name: 'Vietnam', code: Region.VN },
      { name: 'Malaysia', code: Region.MY },
      { name: 'Global', code: Region.GLOBAL },
      { name: 'Islamic', code: Region.ISLAMIC },
      { name: 'Non Islamic', code: Region.NON_ISLAMIC },
      { name: 'Mexico', code: Region.MX },
      { name: 'Brazil', code: Region.BR },
      { name: 'Colombia', code: Region.CO },
      { name: 'Japan', code: Region.JP },
      { name: 'Austria', code: Region.AT },
      { name: 'Germany', code: Region.DE },
      { name: 'Nigeria', code: Region.NG },

    ];

    const dspCountryFlags = [
      { name: 'India', code: Region.IN },
      { name: 'Indonesia', code: Region.ID },
    ];

    const countryFlags = isDspCampaign ? dspCountryFlags : nonDSPCountryFlags;

    const isSelectedCountry = (region) => {
      return draft.preferedRegions
        ? draft.preferedRegions.indexOf(region) != -1
        : false;
    };

    const countryListElm = (
      <div style={styles.countryContainer}>
        {countryFlags.map((country, countryIndex) => {
          return (
            <span
              key={`country-${countryIndex}`}
              style={
                isSelectedCountry(country.code)
                  ? styles.selectedCountry
                  : styles.unSelectedCountry
              }
              onClick={(e) => {
                this.handleCountryChange(
                  country.code,
                  isSelectedCountry(country.code),
                );
              }}
            >
              {country.name}
            </span>
          );
        })}
      </div>
    );

    if (isDspCampaign) {
      rightElements.push(
        <div style={{ float: 'right' }} key="actionButtons">
          <IconButton
            key="saveButton"
            onClick={this.onSubmit}
            style={styles.actionButton}
            disabled={!editable || this.props.pristine}
          >
            <FontIcon
              className="material-icons"
              color={this.props.pristine ? grey500 : indigo500}
              style={{ fontSize: '2em' }}
            >
              save
            </FontIcon>
          </IconButton>
          <IconButton
            key="infoButton"
            onClick={this.onOverride}
            style={styles.actionButton}
            disabled={
              !editable || !this.props.pristine || userRole != Role.ADMIN
            }
            tooltip={
              !this.props.pristine
                ? 'Save Pending'
                : userRole != Role.ADMIN
                ? 'Not allowed'
                : null
            }
          >
            <FontIcon
              className="material-icons"
              color={grey500}
              hoverColor={cyan500}
              style={{ fontSize: '2em' }}
            >
              sync
            </FontIcon>
          </IconButton>
          <IconButton
            key="publishButton"
            onClick={() => {
              this.props.onPublish();
            }}
            style={styles.actionButton}
            disabled={publishButtonDisability}
            tooltip={publishButtonTooltipText}
          >
            <FontIcon
              className="material-icons"
              color={grey500}
              hoverColor={green500}
              style={{ fontSize: '2em' }}
            >
              publish
            </FontIcon>
          </IconButton>
          <IconButton
            key="deleteButton"
            onClick={this.onRemove}
            style={styles.actionButton}
            disabled={!editable || userRole == Role.DESIGNER}
            //  tooltip={'Delete Draft'}
          >
            <FontIcon
              className="material-icons"
              color={grey500}
              hoverColor={red500}
              style={{ fontSize: '2em' }}
            >
              delete
            </FontIcon>
          </IconButton>
        </div>,
      );
    } else {
      rightElements.push(
        <div style={{ float: 'right' }} key="actionButtons">
          <IconButton
            key="saveButton"
            onClick={this.onSubmit}
            style={styles.actionButton}
            disabled={!editable || this.props.pristine}
          >
            <FontIcon
              className="material-icons"
              color={this.props.pristine ? grey500 : indigo500}
              style={{ fontSize: '2em' }}
            >
              save
            </FontIcon>
          </IconButton>
          <IconButton
            key="infoButton"
            onClick={this.onOverride}
            style={styles.actionButton}
            disabled={
              !editable || !this.props.pristine || userRole != Role.ADMIN
            }
            tooltip={
              !this.props.pristine
                ? 'Save Pending'
                : userRole != Role.ADMIN
                ? 'Not allowed'
                : null
            }
          >
            <FontIcon
              className="material-icons"
              color={grey500}
              hoverColor={cyan500}
              style={{ fontSize: '2em' }}
            >
              sync
            </FontIcon>
          </IconButton>
          <IconButton
            key="publishButton"
            onClick={() => {
              this.props.onPublish();
            }}
            style={styles.actionButton}
            disabled={publishButtonDisability}
            tooltip={publishButtonTooltipText}
          >
            <FontIcon
              className="material-icons"
              color={grey500}
              hoverColor={green500}
              style={{ fontSize: '2em' }}
            >
              publish
            </FontIcon>
          </IconButton>
          <IconButton
            key="deleteButton"
            onClick={this.onRemove}
            style={styles.actionButton}
            disabled={!editable || userRole == Role.DESIGNER}
            //  tooltip={'Delete Draft'}
          >
            <FontIcon
              className="material-icons"
              color={grey500}
              hoverColor={red500}
              style={{ fontSize: '2em' }}
            >
              delete
            </FontIcon>
          </IconButton>
          <IconButton
            key="pauseButton"
            onClick={() => this.onPause(!draft.paused)}
            style={styles.actionButton}
            disabled={
              draft.paused == null || !editable || userRole == Role.DESIGNER
            }
            tooltip={draft.paused ? 'Resume Campaign' : 'Pause Campaign'}
          >
            <FontIcon
              className="material-icons"
              color={grey500}
              hoverColor={red500}
              style={{ fontSize: '2em' }}
            >
              {draft.paused ? 'replay' : 'pause'}
            </FontIcon>
          </IconButton>
        </div>,
      );
    }

    if (this.props.detailed) {
      return (
        <div style={styles.width100}>
          <form className="form" style={styles.form} onSubmit={this.onSubmit}>
            <div style={styles.detailsFull}>{countryListElm}</div>
            <div style={styles.detailsLeft}>{leftElements}</div>
            <div style={styles.detailsMiddle}>{middleElements}</div>

            <div style={{ ...styles.detailsRight }}>{rightElements}</div>
          </form>
        </div>
      );
    } else {
      return (
        <div style={styles.width100} data-store={this.props}>
          <div style={styles.leftDiv}>
            <div>
              <span style={styles.spanLabel}>Title: </span>
              <span>{draft.peek ? draft.peek.title : ''}</span>

              <span style={{ ...styles.spanLabel, marginLeft: '20px' }}>
                ID:
                <a
                  target="_blank"
                  href={
                    '/#/' +
                    this.props.role +
                    '/drafts/draftIds/' +
                    draft.draftId
                  }
                >
                  {draft.draftId}
                </a>
              </span>
              {draft.paused ? (
                <span style={{ ...styles.disclaimer }}>Campaign Paused</span>
              ) : null}
            </div>
            <div>

              <span style={styles.spanLabel}>Short Title: </span>
              <span>{draft.peek ? draft.peek.shortTitle : ''}</span>
              <span style={{ ...styles.spanLabel, marginLeft: '20px' }}>
                ID: {draft.draftId}
              </span>

              {draft.peek && (
                <span style={{ ...styles.spanLabel, marginLeft: '20px' }}>
                  {draft.peek.liveVideoPeek
                    ? 'PeekType: Live'
                    : draft.peek.nativeVideoUrl
                    ? 'PeekType: Native'
                    : ''}
                </span>
              )}
            </div>
            {warningTextGLAM}
            <div style={{ display: 'block' }}>
              <span style={styles.spanLabel}>Peek Url:</span>
              {peekUrl ? (
                <span>
                  <a href={peekUrl} target="_blank">
                    {Utils.truncate(peekUrl, 50)}
                  </a>
                </span>
              ) : null}
            </div>
            {draft.peek && draft.peek.summary ? (
              <div style={{ display: 'block' }}>
                <span style={styles.spanLabel}>Summary: </span>
                <span>{Utils.truncate(draft.peek.summary, 75)}</span>
              </div>
            ) : null}
            <div style={{ display: 'block' }}>
              <span style={{ ...styles.spanLabel }}>Categories: </span>
              <span style={{ display: 'inline-block', flexWrap: 'wrap' }}>
                {draft.categoryIds
                  ? draft.categoryIds.map((categoryId) => {
                      let category = this.state.categoryMap.get(categoryId);
                      let displayName =
                        category == null
                          ? 'Not Supported'
                          : category.displayName;
                      return (
                        <Chip
                          style={styles.readableChip}
                          labelStyle={{ lineHeight: '1.5em' }}
                          key={categoryId}
                        >
                          {displayName}
                        </Chip>
                      );
                    })
                  : 'None'}
              </span>
              {draft.priority > 0 ? (
                <span
                  style={{
                    display: 'inline-block',
                    flexWrap: 'wrap',
                    marginLeft: '20px',
                  }}
                >
                  <Chip //style={styles.highPriority}
                    backgroundColor={highPriorityBackgroundColor}
                    labelColor={highPriorityLabelColor}
                    labelStyle={{ lineHeight: '1.5em' }}
                  >
                    {draft.priority === 1 && 'High Priority 1'}
                    {draft.priority === 2 && 'High Priority 2'}
                    {draft.priority === 3 && 'Fixed Position 1'}
                  </Chip>
                </span>
              ) : null}
              {draft.peek && draft.peek.ctaUrl ? (
                draft.peek.shouldUnlock ? (
                  <span
                    style={{
                      display: 'inline-block',
                      flexWrap: 'wrap',
                      marginLeft: '20px',
                    }}
                  >
                    <Chip
                      backgroundColor={blue300} //labelColor={highPriorityLabelColor}
                      labelStyle={{ lineHeight: '1.5em' }}
                    >
                      After Unlock
                    </Chip>
                  </span>
                ) : (
                  <span
                    style={{
                      display: 'inline-block',
                      flexWrap: 'wrap',
                      marginLeft: '20px',
                    }}
                  >
                    <Chip //backgroundColor={blue300} //labelColor={highPriorityLabelColor}
                      labelStyle={{ lineHeight: '1.5em' }}
                    >
                      On Lockscreen
                    </Chip>
                  </span>
                )
              ) : null}
            </div>
            <div>
              <span style={styles.spanLabel}>Session Mode: </span>

              {draft &&
                Utils.getRenderSessionData(draft).map((renderSession) => {
                  return (
                    <Chip
                      style={styles.readableChip}
                      labelStyle={{ lineHeight: '1.5em' }}
                      key={renderSession}
                    >
                      {sessionModeMapping[renderSession]}
                    </Chip>
                  );
                })}
              {glanceDraftData.peek &&
              glanceDraftData.peek.glanceContext != null ? (
                <span>
                  <span style={{ ...styles.spanLabel, marginLeft: '20px' }}>
                    Glance Context:{' '}
                  </span>
                  <span>
                    {glance_context(glanceDraftData.peek.glanceContext)}
                  </span>
                </span>
              ) : null}
              {draft.publisherData ? (
                <span>
                  <span style={{ ...styles.spanLabel, marginLeft: '20px' }}>
                    Publisher:{' '}
                  </span>
                  <span>{draft.publisherData.displayName}</span>
                </span>
              ) : null}
            </div>
          </div>
          <div style={styles.rightTopCornerDiv}>
            {!this.props.pristine ? (
              <div style={{ ...styles.disclaimer }}>Some changes not saved</div>
            ) : null}
            <div style={{ display: 'inline-block', margin: '0 10px' }}>
              Source: {draft.peek ? draft.peek.sourceName : ''}
            </div>
            <div style={{ display: 'inline-block', margin: '0 10px' }}>
              {draft.peek ? Utils.getReadableNumber(draft.peek.heartCount) : ''}{' '}
              <FontIcon
                className="material-icons"
                color={grey500}
                style={{ fontSize: '1em' }}
              >
                favorite
              </FontIcon>
            </div>
            <div style={{ display: 'inline-block', margin: '0 10px' }}>
              {countryFlags.map((country) => {
                return (
                  isSelectedCountry(country.code) && (
                    <span style={styles.selectedCountry}>{country.name}</span>
                  )
                );
              })}
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    studioAppConfig: state.studioAppConfig,
  };
};
export default connect(mapStateToProps)(GlanceDraftDetails);



// WEBPACK FOOTER //
// ./src/pages/drafts/components/GlanceDraftDetails.tsx